import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/plugins/axios'
import i18n from '@/i18n'
import masterDataModule from '@/store/modules/master-data'
import companyModule from '@/store/modules/company'
import planningModule from '@/store/modules/planning'
import { GlobalState, Sidebar, SidebarItem, UiLanguageItem } from '@/types'
import * as getterTypes from './getter-types'
import * as mutationTypes from './mutation-types'
import * as actionTypes from '@/store/action-types'
import {
  UserAbsencesPayload,
  SetEmployeePasswordPayload,
  ChangeEmployeePasswordPayload,
  CompanySettingsPayload,
  EmployeeTimeModelPayload,
  EducationPayload,
  JobPayload,
  SpecializationPayload,
  DetailPayload,
  CompetencePayload,
  EmployeeCompetencePayload,
  EmployeeQualityPayload,
  EmployeeQcqQualificationPayload,
  CreateCalendarEventPayload,
  DeleteCalendarEventPayload,
  GenerateReportPayload,
  EmployeeDataPayload,
  EmployeeHierarchyPayload,
  SchedulerAutoPlanningPayload,
  AddressPayload,
  AddressEmployeePayload,
  AdditionalFieldsPayload,
  NotePayload,
  DispositionJobPayload,
  MonthStatisticPayload,
  SelectedSubstitutionPayload,
  AdditionalServicesPayload,
  AdditionalServicePayload,
  InvoicePayload,
  CreateInvoicesPayload,
  EmployeeAdditionalFieldsPayload,
  ProjectSearchRequest,
  AdditionalFieldsProjectPayload,
  InsertProjectAddressRequestPayload,
  UpdateProjectAddressRequestPayload,
  DeleteProjectAddressRequestPayload,
  ProjectAddressSearchRequestPayload,
  AddressNotePayload,
  EmployeePlanDetailPayload,
  KopfFussDataPayload,
  ProjectReprintPayload,
  BelegDatenPayload,
  PostCodeDataPayload,
  ReplacementPayload,
  ReplacementDetailsPayload,
  AssignEmployeeToReplacementPayload,
  ReplacementPersonListPayload,
  MultiReportPayload,
  CancelBookingPayload,
  StartBookingPayload,
  PositionenBookingPayload,
  MengenBookingPayload,
  BelegBookingPayload,
  FibuBookingPayload,
  SaveMengenStepPayload,
  SaveFibuStepPayload,
  SaveBelegStepPayload,
  PapieriBookingPayload,
  FinishBookingPayload,
  HasFibuBookingPayload,
  DeleteProjectPayload,
  DeleteProjectDetailPayload,
  EditProjectDetailPayload,
  InsertAdressVorgabenPayload,
  DeleteAdressVorgabenpayload,
  UpdateAdressVorgabenPayload,
  CreateProjectPayload,
  ProductSearchRequest,
  CreateProjectDetailPayload,
  GetPricingRequestPayload,
  SaveNoteAttachmentPayload,
  FindPersonDispoJobPayload,
  LoginPayload,
  LogUserOutByTokenPayload,
  PlaningFilterPayload,
  ProfitCenterAdditionalFieldsUpdatePayload,
  UpdateVerantwortungsDataRequest,
  SaveEmployeeRequirementsPayload,
  SaveSecurityRequirementsPayload,
  DeleteEmployeeRequirementsPayload,
  DeleteSecurityRequirementsPayload,
  UpdateProfitCenterAndDepartmentPayload,
  ProjectGeneralAddressSearchRequestPayload,
  GetProductTextsPayload,
  UpsertProdukteTextePayload,
  UpsertProdukteBezeichnungenPayload,
  UpsertProdukteBemerkungenPayload,
  UpdateProductPayload,
  CreateProductPayload,
  ProductSearchPayload,
  UpsertZusatzfelderRequest,
  UpsertProduktNotizenRequest,
  DeleteProductStoragePayload,
  UpsertProductPricePayload,
  UpsertProductAddressPricePayload,
  PlanningAssistantPeriodicityPayload,
  UpdateProjectPayload,
  ProfitCenterAdditionalFieldsMultiLanguageUpdatePayload,
  KommissionSearchRequest,
  UpsertKommissionZusatzfelderRequest,
  UpsertKommissionNotizenRequest,
  AddKommissionRequest,
  UpdateKommissionRequest,
  UpsertAbonnementeRequest,
  FetchCockpitPayload,
  UpsertMitarbeiterRequest,
  UpsertMitarbeiterKontaktinfosRequest,
  SaveDocumentAttachmentRequest,
  ProjectAssistantDefaultsPayload, ToolsActionPayload
} from '@/types/payload'
import {
  CompetenceResponse,
  CompanyStructureForPlanningResponse,
  CompetenceRow,
  DetailResponse,
  DetailRow,
  JobsResponse,
  JobsRow,
  LevelOfEducationResponse,
  LevelOfEducationRow,
  SpecializationResponse,
  SpecializationRow,
  ShiftElement,
  UserInformationResponse,
  UserInformationAbsencesResponse,
  CompanySettingsResponse,
  EmployeeCostCenterResponse,
  EmployeeCostCenterResponseItem,
  EmployeeQcqQualificationResponse,
  EmployeeQcqCompetenceResponse,
  EmployeeQcqQualityResponse,
  ReportTreeItemResponse,
  SimpleWeekTimeModelResponse,
  AddressProjectAddressResponse,
  ProjectAddressSearchResponse,
  SaveUpdateDeleteProjectAddressResponse,
  GetCountriesResponse,
  AddressNoteResponse,
  GetProjectReceiptsResponse,
  GetArchiveResponse,
  UpdateKopfFussResponse,
  GetFinancialActivityResponse,
  GetPdfUrlResponse,
  ReprintListResponse,
  ProjectReprintResponse,
  ProjectReprintCancelResponse,
  GetLookupsResponse,
  GetBelegDataResponse,
  UpdateBelegDataResponse,
  GetOrtPlzResponse,
  ReplacementListResponse,
  ReplacementDispositionResponse,
  UpdateReplacementListResponse,
  SaveReplacementDetailsResponse,
  FinishReplacementResponse,
  AssignReplacementResponse,
  UpdateReplacementPersonListResponse,
  ResponseBase,
  InvoiceResponse,
  StartBookingResponse,
  PositionenBookingResponse,
  MengenBookingResponse,
  BelegBookingResponse,
  FibuBookingResponse,
  PapieriBookingResponse,
  SaveMengenStepResponse,
  SaveFibuStepResponse,
  SaveBelegStepResponse,
  HasFibuBookingResponse,
  AddressProjectSpecificationsResponse,
  InsertAdressVorgabenResponse,
  GetToolsResponse,
  RunToolResponse,
  AdressZusatzfelderTypesResponse,
  GetPaymentInformationResponse,
  GetContactListResponse,
  GetEmployeePlanDetailResponse,
  StartAssistantResponse,
  GetSachbearbeiterResponse,
  CreateProjectResponse,
  StartDetailAssistantResponse,
  ProductSearchResponse,
  CreateProjectDetailResponse,
  GetPricingResponse,
  GetEmployeeResponse,
  GetUnitCodeListResponse,
  GetNoteAttachmentListResponse,
  SaveNoteAttachmentResponse,
  DeleteNoteAttachmentResponse,
  AdressenNotizenIndexResponse,
  AutomaticOneResponse,
  GetProjectDetailLookupsResponse,
  InvoiceStatusResponse,
  LoginResponse,
  LoggedInUsersResponse,
  QuickInsertResponse,
  SpracheResponse,
  GetEmployeeLevelResponse,
  UpdateEmployeeResponse,
  GetPlaningFilterData,
  ProfitCenterAdditionalFieldsGetItemResponse,
  VerantwortungsDataResponse,
  EmployeeRequirementsResponse,
  EmployeeRequirementsValuesResponse,
  EmployeeAndSecurityResponse,
  EmployeeSecurityRoleResponse,
  AgencyResponse,
  PrintingActivityResponse,
  ProductGroupResponse,
  ProductZusatzfelderTypesResponse,
  ProductTextArtResponse,
  GetProductTextsResponse,
  GetProductDescriptionResponse,
  GetProductNoticesResponse,
  ProductUnitResponse,
  ProductSubstituteResponse,
  ProductAdditionalFieldsGetItemResponse,
  ProductNotesResponse,
  ProductNotesMetaDataResponse,
  ProductNoteUpsertResponse,
  UpsertProductResponse,
  KommissionSearchResponse,
  KommissionAdditionalFieldsGetItemResponse,
  KommissionNotesMetaDataResponse,
  KommissionNotesResponse,
  KommissionNoteUpsertResponse,
  UpsertAbonnementeResponse,
  KommissionResponse,
  KommissionAbonementeMetadataResponse,
  KommissionAbonementeResponse,
  LeitstandStructurResponse,
  PlanungLookupProjekteResponse,
  EmployeeMetadataResponse,
  DocumentGroupListResponse,
  SaveDocumentResponse,
  ProjectAssistantDefaultsResponse,
} from '@/types/service-response'
import InvalidCredentialsError from '@/model/error/InvalidCredentialsError'
import { CurrentUser } from '@/model/CurrentUser'
import LogoutUserError from '@/model/error/LogoutUserError'
import { LevelOfEducation } from '@/model/qcq/LevelOfEducation'
import { Jobs } from '@/model/qcq/Jobs'
import { Specialization } from '@/model/qcq/Specialization'
import { Detail } from '@/model/qcq/Detail'
import { Competence } from '@/model/qcq/Competence'
import * as qcqService from '@/services/qcq-service'
import { fetchMenuData } from './menu-data'
import { CompanySettings } from '@/model/settings/CompanySettings'
import { CurrentUserAbsence } from '@/model/CurrentUserAbsence'
import { EmployeeCostCenter } from '@/model/employee/EmployeeCostCenter'
import { Quality } from '@/model/qcq/Quality'
import { EmployeeQcqQualification } from '@/model/employee/EmployeeQcqQualification'
import { EmployeeQcqCompetence } from '@/model/employee/EmployeeQcqCompetence'
import { EmployeeQcqQuality } from '@/model/employee/EmployeeQcqQuality'
import messagingModule from '@/store/modules/messaging'
import { ReportMenuTreeItem } from '@/model/reporting/ReportMenuTreeItem';
import absencesModule from '@/store/modules/absences/absencesIndex'
import { SecurityData } from '@/model/SecurityData'
import { Balance } from '@/model/Balance'
import dashboardModule from '@/store/modules/dashboard'
import { EmployeeHierarchyList } from '@/model/settings/EmployeeHierarchyList'
import { EmailTemplate } from '@/model/settings/EmailTemplate'
import { EmailSmtpSettings } from '@/model/settings/EmailSmtpSettings'
import { Address } from '@/model/planning/Address'
import { AddressGroup } from '@/model/addresses/AddressGroup'
import { AddressSidebarItem } from '@/model/addresses/AddressSidebarItem'
import { Title } from '@/model/addresses/Title'
import { Land } from '@/model/addresses/Land'
import { AddressDetail } from '@/model/addresses/AddressDetail'
import { Salutation } from '@/model/addresses/Salutation'
import { EmployeeFunction } from '@/model/addresses/EmployeeFunction'
import { AddressColor } from '@/model/addresses/AddressColor'
import { AdditionalGroup } from '@/model/additional-fields/AdditionalGroup'
import { AxiosResponse } from 'axios'
import { AddressFunction } from '@/model/addresses/AddressFunction'
import { SimpleWeekTimeModel } from '@/model/master-data/SimpleWeekTimeModel'
import { Note } from '@/model/addresses/Note'
import { NoteType } from '@/model/addresses/NoteType'
import { DispositionJob } from '@/model/disposition/DispositionJob'
import { DispositionJobDetail } from '@/model/disposition/DispositionJobDetail'
import { Version } from '@/model/Version'
import { Changelog } from '@/model/Changelog'
import { DispositionAddress } from '@/model/disposition/DispositionAddress'
import { MonthStatistic } from '@/model/planning/MonthStatistic'
import { DispositionJobEmployee } from '@/model/disposition/DispositionJobEmployee'
import { DispositionJobStatus } from '@/model/disposition/DispositionJobStatus'
import { WorkRhythm } from '@/model/disposition/WorkRhythm'
import { Substitution } from '@/model/disposition/Substitution'
import { NoteEditMenu, SecurityArea, SecurityComponent } from '@/types/enums'
import { SchedulerSettings } from '@/model/planning/SchedulerSettings'
import { AdditionalServices } from '@/model/planning/AdditionalServices'
import { AdditionalServicesProduct } from '@/model/planning/AdditionalServicesProduct'
import { Currency } from '@/model/planning/Currency'
import { ProjectGroup } from '@/model/project/ProjectGroup'
import { ProjectSearch } from '@/model/project/ProjectSearch'
import { ProjectDetail } from '@/model/project/ProjectDetail'
import { ProjectDetailFooter } from '@/model/project/ProjectDetailFooter'
import { ProjectDetailHeader } from '@/model/project/ProjectDetailHeader'
import { NoteTooltip } from '@/model/planning/NoteTooltip'
import * as securityService from '@/services/security-service'
import { Replacement } from '@/model/disposition/Replacement'
import calendarEventModule from '@/store/modules/calendar-event/calendarEventIndex'
import schedulingModule from '@/store/modules/scheduling'
import { RecruitingGroup } from '@/model/recruiting/RecruitingGroup'
import { CommissionGroup } from '@/model/commissions/CommissionGroup'
import _ from 'lodash'
import { Document } from '@/model/documents/Document'

Vue.use(Vuex)

const state: GlobalState = {
  currentUser: undefined,
  showDrawer: false,
  sidebar: undefined,
  settings: {
    simpleWeekTimeModel: 1,
    industrialTimeModel: 0
  },
  securityData: undefined,
  securityLevel: undefined,

  uiLanguageList: [],

  defaultUiLanguage: {
    code: 'de',
    syzId: 1,
    title: 'Deutsch'
  },

  selectedUiLanguage: undefined,
  updateMenu: false,
  version: undefined,
  showMenuAddress: false,
  showMenuProject: false,
  showMenuDisposition: false,
  dispositionAddress: undefined,
  dispositionJobStatusList: [],
  isDispositionJobStatus: false,
  isCapelo: false,
  isAllDayLong: false
}

export default new Vuex.Store({
  modules: {
    masterData: masterDataModule,
    company: companyModule,
    planning: planningModule,
    messaging: messagingModule,
    absences: absencesModule,
    dashboard: dashboardModule,
    calendarEvent: calendarEventModule,
    scheduling: schedulingModule
  },

  state: state,

  getters: {
    [getterTypes.IS_USER_LOGGED_IN]: (state: GlobalState): boolean => !!state.currentUser,
    [getterTypes.GET_SELECTED_UI_LANGUAGE]: (state: GlobalState): UiLanguageItem | undefined => state.selectedUiLanguage,
    [getterTypes.GET_SECURITY_DATA]: (state: GlobalState): Array<SecurityData> | undefined => state.securityData,
    [getterTypes.GET_SECURITY_LEVEL]: (state: GlobalState): number | undefined => state.securityLevel,
    [getterTypes.GET_CURRENT_USER_ID]: (state: GlobalState): number | undefined => state.currentUser!.id,
    [getterTypes.GET_UPDATE_MENU]: (state: GlobalState): boolean => state.updateMenu,
    [getterTypes.GET_VERSION]: (state: GlobalState): Version | undefined => state.version,
    [getterTypes.GET_SHOW_MENU_ADDRESS]: (state: GlobalState): boolean => state.showMenuAddress,
    [getterTypes.GET_SHOW_MENU_PROJECT]: (state: GlobalState): boolean => state.showMenuProject,
    [getterTypes.GET_SHOW_MENU_DISPOSITION]: (state: GlobalState): boolean => state.showMenuDisposition,
    [getterTypes.GET_IS_ALL_DAY_LONG]: (state: GlobalState): boolean => state.isAllDayLong,
    [getterTypes.GET_DISPOSITION_ADDRESS]: (state: GlobalState): number | undefined => state.dispositionAddress,
    [getterTypes.GET_DISPOSITION_JOB_STATUS_LIST]: (state: GlobalState): Array<any> => state.dispositionJobStatusList,
    [getterTypes.GET_DISPOSITION_JOB_IS_STATUS]: (state: GlobalState): boolean => state.isDispositionJobStatus,
    [getterTypes.GET_DISPOSITION_DEFAULT_DISTANCE]: (state: GlobalState): number => state.currentUser!.dispositionDefaultDistance,
    [getterTypes.GET_CURRENT_USER_DRAG_AND_DROP]: (state: GlobalState): boolean => state.currentUser!.dragAndDrop,
    [getterTypes.GET_CURRENT_USER_RESIZE]: (state: GlobalState): boolean => state.currentUser!.resize,
    [getterTypes.GET_CURRENT_USER_IS_ABSENCE_APPROVE]: (state: GlobalState): boolean => state.currentUser!.isAbsenceApprove,
    [getterTypes.GET_IS_CAPELO]: (state: GlobalState): boolean => state.isCapelo
  },

  mutations: {
    [mutationTypes.SET_CURRENT_USER] (state: GlobalState, payload: CurrentUser | undefined): void {
      state.currentUser = payload
    },

    [mutationTypes.TOGGLE_DRAWER] (state: GlobalState): void {
      state.showDrawer = !state.showDrawer
    },

    [mutationTypes.SET_DRAWER_STATE] (state: GlobalState, value: boolean): void {
      state.showDrawer = value
    },

    [mutationTypes.SET_APP_MENU] (state: GlobalState, payload): void {
      state.sidebar = payload
    },

    [mutationTypes.SET_UI_LANGUAGE] (state: GlobalState, payload: UiLanguageItem): void {
      state.selectedUiLanguage = payload
    },

    [mutationTypes.SET_COMPANYSTRUTURE_MENU] (state: GlobalState, payload: any): void {
      const menuItemToInsert = payload.menuItemToInsert
      menuItemToInsert.children = payload.list
    },

    [mutationTypes.SET_SECURITY_DATA] (state: GlobalState, payload: Array<SecurityData>): void {
      state.securityData = payload
    },

    [mutationTypes.SET_SECURITY_LEVEL] (state: GlobalState, payload: number): void {
      state.securityLevel = payload
    },

    [mutationTypes.SET_UPDATE_MENU_MUTATION] (state: GlobalState, payload: boolean): void {
      state.updateMenu = payload
    },

    [mutationTypes.SET_VERSION] (state: GlobalState, payload: Version): void {
      state.version = payload
    },

    [mutationTypes.SET_SHOW_MENU_ADDRESS_MUTATION] (state: GlobalState, payload: boolean): void {
      state.showMenuAddress = payload
    },

    [mutationTypes.SET_SHOW_MENU_PROJECT_MUTATION] (state: GlobalState, payload: boolean): void {
      state.showMenuProject = payload
    },

    [mutationTypes.SET_SHOW_MENU_DISPOSITION_MUTATION] (state: GlobalState, payload: boolean): void {
      state.showMenuDisposition = payload
    },

    [mutationTypes.SET_DISPOSITION_ADDRESS_MUTATION] (state: GlobalState, payload: number | undefined): void {
      state.dispositionAddress = payload
    },

    [mutationTypes.SET_DISPOSITION_JOB_STATUS_LIST_MUTATION] (state: GlobalState, payload: any): void {
      state.dispositionJobStatusList = payload
    },

    [mutationTypes.SET_IS_DISPOSITION_JOB_STATUS_MUTATION] (state: GlobalState, payload: boolean): void {
      state.isDispositionJobStatus = payload
    },

    [mutationTypes.SET_IS_CAPELO_MUTATION] (state: GlobalState, payload: boolean): void {
      state.isCapelo = payload
    },

    [mutationTypes.SET_IS_ALL_DAY_LONG_MUTATION] (state: GlobalState, payload: boolean): void {
      state.isAllDayLong = payload
    },
  },

  actions: {
    [actionTypes.SET_CURRENT_USER] ({ commit }, payload: CurrentUser | undefined): void {
      commit(mutationTypes.SET_CURRENT_USER, payload)
    },

    [actionTypes.SET_UPDATE_MENU] ({ commit }, payload: boolean): void {
      commit(mutationTypes.SET_UPDATE_MENU_MUTATION, payload)
    },

    [actionTypes.SET_SHOW_MENU_ADDRESS] ({ commit }, payload: boolean): void {
      commit(mutationTypes.SET_SHOW_MENU_ADDRESS_MUTATION, payload)
    },

    [actionTypes.SET_SHOW_MENU_PROJECT] ({ commit }, payload: boolean): void {
      commit(mutationTypes.SET_SHOW_MENU_PROJECT_MUTATION, payload)
    },

    [actionTypes.SET_SHOW_MENU_DISPOSITION] ({ commit }, payload: boolean): void {
      commit(mutationTypes.SET_SHOW_MENU_DISPOSITION_MUTATION, payload)
    },

    [actionTypes.SET_DISPOSITION_ADDRESS] ({ commit }, payload: number | undefined): void {
      commit(mutationTypes.SET_DISPOSITION_ADDRESS_MUTATION, payload)
    },

    [actionTypes.SET_IS_DISPOSITION_JOB_STATUS] ({ commit }, payload: boolean): void {
      commit(mutationTypes.SET_IS_DISPOSITION_JOB_STATUS_MUTATION, payload)
    },

    [actionTypes.SET_IS_ALL_DAY_LONG] ({ commit }, payload: boolean): void {
      commit(mutationTypes.SET_IS_ALL_DAY_LONG_MUTATION, payload)
    },

    async [actionTypes.LOG_USER_IN] ({ commit, dispatch }, payload: LoginPayload) {
      const response = await axios.post('/api/UserInformation/Login', payload)

      const data: LoginResponse = response.data

      if (!data.IsError && data.Success && data.User && data.User.id) {
        localStorage.setItem("token", JSON.stringify(data.User.authToken))
        const currentUser = CurrentUser.createFromUserInformationResponse(data.User)
        const securityData = SecurityData.createFromResponse(data.User.securityData)

        commit(mutationTypes.SET_CURRENT_USER, currentUser)
        commit(mutationTypes.SET_SECURITY_DATA, securityData)
        commit(mutationTypes.SET_SECURITY_LEVEL, data.User.securityLevel)
        dispatch(actionTypes.SELECT_UI_LANGUAGE, currentUser.uiLanguage)

        return response
      } else {
        throw InvalidCredentialsError.createError(data.ErrorMessage)
      }
    },

    async [actionTypes.LOG_USER_IN_BY_TOKEN] ({ commit, dispatch }) {
      const token = JSON.parse(localStorage.getItem('token') as string)
      const response = await axios.get('/api/UserInformation?userInfo=1',{ headers: { Authorization: `${token.tokenType}  ${token.accessToken}` }})

      const data: UserInformationResponse = response.data

      if (data && data.id) {
        localStorage.setItem("token", JSON.stringify(data.authToken))
        const currentUser = CurrentUser.createFromUserInformationResponse(data)
        const securityData = SecurityData.createFromResponse(data.securityData)

        commit(mutationTypes.SET_CURRENT_USER, currentUser)
        commit(mutationTypes.SET_SECURITY_DATA, securityData)
        commit(mutationTypes.SET_SECURITY_LEVEL, data.securityLevel)
        dispatch(actionTypes.SELECT_UI_LANGUAGE, currentUser.uiLanguage)

        return response
      } else {
        throw InvalidCredentialsError.createError(null)
      }
    },

    async [actionTypes.LOG_USER_OUT] ({ commit, dispatch }, payload: boolean) {
      await axios.get('/api/UserInformation/Logout')
      const data = true // TODO: perform logout service call

      if (data) {
        if(payload) {
          await dispatch(actionTypes.MESSAGING_DELETE_MESSAGES)
        }
        commit(mutationTypes.SET_CURRENT_USER, undefined)
        dispatch(actionTypes.SCHEDULING_SET_PARAMETERS, undefined)
        localStorage.removeItem('token')
      } else {
        throw new LogoutUserError()
      }
    },

    async [actionTypes.FETCH_LANGUAGE_LIST] ({ commit, state }): Promise<void> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            'sp': 'Sprachen_GetList'
          }
        })
      if(!response.data.IsError && response.data.Data) {
        state.uiLanguageList = response.data.Data.map((item: SpracheResponse) => {

          return {
            code: item.Code.toLowerCase(),
            title: item.Bezeichnung,
            syzId: item.ID
          }
        })
      }
    },

    [actionTypes.LOAD_APP_MENU] ({ commit }) {
      const menuData: Sidebar = fetchMenuData()
      if(state.securityData) {
        const showDashboard: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Dashboard)
        const showMasterData: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Stammdaten)
        const showAddress: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Address)
        const showCommissions: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Commission)
        const showProducts: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Products)
        const showQcq: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Qcq)
        const showWork: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Works)
        const showShift: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Shifts)
        const showProject: boolean = state.isCapelo && securityService.isVisible(SecurityArea.Menu, SecurityComponent.Projects)
        const showPersonalDisposition: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.PersonalDisposition)
        const showAllocation: boolean = securityService.isVisible(SecurityArea.PersonalDisposition, SecurityComponent.Allocation)
        const showSubstitution: boolean = securityService.isVisible(SecurityArea.PersonalDisposition, SecurityComponent.Substitution)
        const showReallocation: boolean = securityService.isVisible(SecurityArea.PersonalDisposition, SecurityComponent.Reallocation)
        const showTools: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Tools)
        const showSettings: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Settings)
        const showCockpit: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Cockpit)
        const showRecruiting: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Recruiting)

        if(!showDashboard) {
          const filteredChildren: Array<SidebarItem> = menuData.children.filter((item: SidebarItem) => item.id !== "esoft1")
          menuData.children = filteredChildren
        }

        if(!showMasterData) {
          const filteredChildren: Array<SidebarItem> = menuData.children.filter((item: SidebarItem) => item.id !== "esoft2")
          menuData.children = filteredChildren
        }

        if(!showAddress) {
          let filteredChildren: Array<SidebarItem> = menuData.children.map((item: SidebarItem) => {
            if(item.id !== "esoft2") {
              return item
            } else {
              if(item.children) {
                const filteredItem: any = item.children.filter((item: any) => item.id !== "esoft2.6")
                if (filteredItem) {
                  item.children = filteredItem
                }
              }
              return item
            }
          })
          menuData.children = filteredChildren
        }

        if(!showCommissions) {
          let filteredChildren: Array<SidebarItem> = menuData.children.map((item: SidebarItem) => {
            if(item.id !== "esoft2") {
              return item
            } else {
              if(item.children) {
                const filteredItem: any = item.children.filter((item: any) => item.id !== "esoft2.8")
                if (filteredItem) {
                  item.children = filteredItem
                }
              }
              return item
            }
          })
          menuData.children = filteredChildren
        }

        if(!showProducts) {
          let filteredChildren: Array<SidebarItem> = menuData.children.map((item: SidebarItem) => {
            if(item.id !== "esoft2") {
              return item
            } else {
              if(item.children) {
                const filteredItem: any = item.children.filter((item: any) => item.id !== "esoft2.7")
                if (filteredItem) {
                  item.children = filteredItem
                }
              }
              return item
            }
          })
          menuData.children = filteredChildren
        }

        if(!showQcq) {
          let filteredChildren: Array<SidebarItem> = menuData.children.map((item: SidebarItem) => {
            if(item.id !== "esoft2") {
              return item
            } else {
              if(item.children) {
                const filteredItem: any = item.children.filter((item: any) => item.id !== "esoft2.3")
                if (filteredItem) {
                  item.children = filteredItem
                }
              }
              return item
            }
          })
          menuData.children = filteredChildren
        }

        if(!showWork) {
          let filteredChildren: Array<SidebarItem> = menuData.children.map((item: SidebarItem) => {
            if(item.id !== "esoft2") {
              return item
            } else {
              if(item.children) {
                const filteredItem: any = item.children.filter((item: any) => item.id !== "esoft2.4")
                if (filteredItem) {
                  item.children = filteredItem
                }
              }
              return item
            }
          })
          menuData.children = filteredChildren
        }

        if(!showShift) {
          let filteredChildren: Array<SidebarItem> = menuData.children.map((item: SidebarItem) => {
            if(item.id !== "esoft2") {
              return item
            } else {
              if(item.children) {
                const filteredItem: any = item.children.filter((item: any) => item.id !== "esoft2.5")
                if (filteredItem) {
                  item.children = filteredItem
                }
              }
              return item
            }
          })
          menuData.children = filteredChildren
        }

        if(!showProject) {
          const filteredChildren: Array<SidebarItem> = menuData.children.filter((item: SidebarItem) => item.id !== "esoft8")
          menuData.children = filteredChildren
        }

        if(!showPersonalDisposition) {
          const filteredChildren: Array<SidebarItem> = menuData.children.filter((item: SidebarItem) => item.id !== "esoft7")
          menuData.children = filteredChildren
        }

        if(!showAllocation) {
          let filteredChildren: Array<SidebarItem> = menuData.children.map((item: SidebarItem) => {
            if(item.id !== "esoft7") {
              return item
            } else {
              if(item.children) {
                const filteredItem: any = item.children.filter((item: any) => item.id !== "esoft7.1")
                if (filteredItem) {
                  item.children = filteredItem
                }
              }
              return item
            }
          })
          menuData.children = filteredChildren
        }

        if(!showSubstitution) {
          let filteredChildren: Array<SidebarItem> = menuData.children.map((item: SidebarItem) => {
            if(item.id !== "esoft7") {
              return item
            } else {
              if(item.children) {
                const filteredItem: any = item.children.filter((item: any) => item.id !== "esoft7.2")
                if (filteredItem) {
                  item.children = filteredItem
                }
              }
              return item
            }
          })
          menuData.children = filteredChildren
        }

        if(!showReallocation) {
          let filteredChildren: Array<SidebarItem> = menuData.children.map((item: SidebarItem) => {
            if(item.id !== "esoft7") {
              return item
            } else {
              if(item.children) {
                const filteredItem: any = item.children.filter((item: any) => item.id !== "esoft7.3")
                if (filteredItem) {
                  item.children = filteredItem
                }
              }
              return item
            }
          })
          menuData.children = filteredChildren
        }

        if(!showTools) {
          const filteredChildren: Array<SidebarItem> = menuData.children.filter((item: SidebarItem) => item.id !== "esoft9")
          menuData.children = filteredChildren
        }

        if(!showSettings) {
          const filteredChildren: Array<SidebarItem> = menuData.children.filter((item: SidebarItem) => item.id !== "esoft6")
          menuData.children = filteredChildren
        }

        if(!showCockpit) {
          const filteredChildren: Array<SidebarItem> = menuData.children.filter((item: SidebarItem) => item.id !== "esoft10")
          menuData.children = filteredChildren
        }

        if(!showRecruiting) {
          const filteredChildren: Array<SidebarItem> = menuData.children.filter((item: SidebarItem) => item.id !== "esoft11")
          menuData.children = filteredChildren
        }

        commit(mutationTypes.SET_APP_MENU, menuData)

      } else {
        commit(mutationTypes.SET_APP_MENU, menuData)
      }
    },

    async [actionTypes.LOAD_CURRENT_USER_ABSENCES] ({ commit }, payload: UserAbsencesPayload): Promise<Array<CurrentUserAbsence>> {
      const response = await axios.get('/api/UserInformation', {
        params: payload
      })

      const data: UserInformationAbsencesResponse = response.data

      return CurrentUserAbsence.createListFromResponse(data)
    },

    async [actionTypes.LOAD_CURRENT_USER_BALANCE] ({ commit }, payload: number): Promise<Balance> {
      const response = await axios.get('/api/UserInformation', {
        params: {
          'ID': payload
        }
      })
      return Balance.createFromResponse(response.data[0])
    },

    /* QCQ services */

    async [actionTypes.LOAD_EDUCATION] ({}) {
      const response = await axios.get('/api/QCQ')
      const data: LevelOfEducationResponse = response.data

      return LevelOfEducation.createListFromResponse(data)
    },

    async [actionTypes.LOAD_EDUCATION_ROW] ({ commit, state }, payload: { currentSelectedRowId: number, operation: number }) {
      const response = await axios.get('/api/QCQ', {
        params: {
          'BildungsgradeIDOneRow': payload.currentSelectedRowId
        }
      })

      const data: Array<LevelOfEducationRow> = response.data

      return qcqService.createLevelOfEducationDialogData(data, payload.operation)
    },

    async [actionTypes.LOAD_JOBS] ({ commit, state }, payload: string) {
      const response = await axios.get('/api/QCQ', {
        params: {
          'BildsungradID': payload
        }
      })
      const data: JobsResponse = response.data
      return Jobs.createListFromResponse(data)
    },

    async [actionTypes.LOAD_JOBS_ROW] ({ commit, state }, payload: { currentSelectedRowId: number, operation: number }) {
      const response = await axios.get('/api/QCQ', {
        params: {
          'BerufeIDOneRow': payload.currentSelectedRowId
        }
      })
      const data: Array<JobsRow> = response.data
      return qcqService.createJobsDialogData(data, payload.operation)
    },

    async [actionTypes.LOAD_SPECIALIZATION] ({ commit, state }, payload: string) {
      const response = await axios.get('/api/QCQ', {
        params: {
          'BerufeID': payload
        }
      })
      const data: SpecializationResponse = response.data
      return Specialization.createListFromResponse(data)
    },

    async [actionTypes.LOAD_SPECIALIZATION_ROW] ({ commit, state }, payload: { currentSelectedRowId: number, operation: number }) {
      const response = await axios.get('/api/QCQ', {
        params: {
          'FachrichtungenID': payload.currentSelectedRowId
        }
      })
      const data: Array<SpecializationRow> = response.data

      return qcqService.createSpecializationDialogData(data, payload.operation)
    },

    async [actionTypes.LOAD_DETAIL] ({ commit, state }, payload: string) {
      const response = await axios.get('/api/QCQ', {
        params: {
          'FachrichtungID': payload
        }
      })
      const data: DetailResponse = response.data
      return Detail.createListFromResponse(data)
    },

    async [actionTypes.LOAD_DETAIL_ROW] ({ commit, state }, payload: { currentSelectedRowId: number, operation: number }) {
      const response = await axios.get('/api/QCQ', {
        params: {
          'DetailsID': payload.currentSelectedRowId
        }
      })
      const data: Array<DetailRow> = response.data

      return qcqService.createDetailDialogData(data, payload.operation)
    },

    async [actionTypes.LOAD_COMPETENCE] ({ commit, state }, payload: number) {
      const response = await axios.get('/api/QCQ', {
        params: {
          'Competence': payload
        }
      })
      const data: CompetenceResponse = response.data

      return Competence.createListFromResponse(data)
    },

    async [actionTypes.LOAD_COMPETENCE_ROW] ({ commit, state }, payload: { currentSelectedRowId: number, operation: number }) {
      const response = await axios.get('/api/QCQ', {
        params: {
          'CompetenceIDOneRow': payload.currentSelectedRowId
        }
      })
      const data: Array<CompetenceRow> = response.data

      return qcqService.createCompetenceDialogData(data, payload.operation)
    },

    /* Company Structure service */

    async [actionTypes.LOAD_COMPANY_STRUCTURE] ({ commit, state }) {
      // old api has Struture endpoint, new is fixed
      const endpoint = process.env.VUE_APP_API_VERSION === 'old' ? '/api/CompanyStruture' : '/api/CompanyStructure'

      const response = await axios.get(endpoint, {
        params: {
          'ID': state.currentUser!.id,
          'sprache': state.currentUser!.uiLanguage.syzId
        }
      })

      const data: CompanyStructureForPlanningResponse = response.data

      return data
    },

    async [actionTypes.FETCH_MAX_STARS] ({ commit, state }) {
      const response = await axios.get('/api/Shift/GetMaxStars')
      return response.data
    },

    /* Planning services */

    // GrabShifts - Get Shifts definition information
    async [actionTypes.GET_SHIFTS_DEFINITION] ({ commit, state }, payload: {
      profitCenter: number
      planningGroup: number
    }) {
      const response = await axios.get('/api/Planung', {
        params: {
          'ProfitCenter': payload.profitCenter, // department of the selection box
          'Planungsgruppe': payload.planningGroup // planning group of the selection box
        }
      })
      return response.data // Array<ShiftDefinition>
    },

    // ReadZusatzfelder - Get Zusatzfelder information
    async [actionTypes.GET_ADDITIONAL_FIELDS] ({ commit, state }, payload: {
      language: number
    }) {
      const response = await axios.get('/api/Planung', {
        params: {
          'Sprache': payload.language
        }
      })
      return response.data // Array<ProjectAdditionalFields>
    },

    async [actionTypes.DELETE_SHIFT] ({ commit, state }, payload: number) {
      const response = await axios.post('/api/PlanungActions', null, {
        params: {
          'DeleteProjektSchichtDetailID': payload
        }
      })
      return response.data
    },

    // RemoveProjectSerien - delete project Serien
    async [actionTypes.DELETE_PROJECT_SERIEN] ({ commit, state }, payload: number) {
      const response = await axios.post('/api/PlanungActions', null, {
        params: {
          'ProjektSerienID': payload
        }
      })
      return response.data // boolean
    },

    // UpdateProjectSerien - Update project Serien
    async [actionTypes.UPDATE_PROJECT_SERIEN] ({ commit, state }, payload: {
      element: ShiftElement,
      fixiert: boolean,
      isFreePlanning: boolean,
      DatumStart: Date,
      DatumEnde: Date,
      number: number
    }) {
      let params: any
      const element = payload.element
      if (!payload.isFreePlanning) {
        params = {
          'Zeile': element.Zeile !== null ? element.Zeile.toString() : '',
          'hourStart': element.hourStart !== null ? element.hourStart.toString() : '',
          'hourEnde': element.hourEnde !== null ? element.hourEnde.toString() : '',
          'minEnde': element.minEnde !== null ? element.minEnde.toString() : '',
          'MitarbeiterID': element.MitarbeiterID !== null ? element.MitarbeiterID.toString() : '',
          'NotizElement': element.NotizElement !== null ? element.NotizElement.toString() : '',
          'ArbeitID': element.ArbeitID !== null ? element.ArbeitID.toString() : '',
          'ProjektSerie': element.ProjectSerie !== null ? element.ProjectSerie.toString() : ''
        }
      } else {
        params = {
          'ProjektSerie': element.ProjectSerie !== null ? element.ProjectSerie.toString() : '',
          'Zeile': element.Zeile !== null ? element.Zeile.toString() : '',
          'DatumStartHour': element.hourStart.toString(),
          'DatumStartMin': element.minStart.toString(),
          'DatumEndeHour': element.hourEnde.toString(),
          'DatumEndeMin': element.minEnde.toString(),
          'MitarbeiterID': element.MitarbeiterID !== null ? element.MitarbeiterID.toString() : '',
          'NotizElement': element.NotizElement !== null ? element.NotizElement.toString() : '',
          'ArbeitID': element.ArbeitID !== null ? element.ArbeitID.toString() : '',
          'fixiert': payload.fixiert !== null ? payload.fixiert.toString() : '',
          'number': payload.number !== null ? payload.number.toString() : ''
        }
      }
      const response = await axios.get('/api/Planung', {
        params: params
      })
      return response.data // boolean
    },

    async [actionTypes.READ_PROJECTS] ({ commit, state }, payload: {
      projectSerie: number // schicht ID
      language: number
    }) {
      const response = await axios.get('/api/Planung', {
        params: {
          'ProjectSerie': payload.projectSerie,
          'sprache': payload.language
        }
      })
      return response.data // Array<ShiftElement>
    },

    async [actionTypes.INSERT_CALENDAR_ART] ({ commit, state }, payload: CreateCalendarEventPayload) {
      const response = await axios.post('/api/Planung', null, {
        params: {
          'Title': payload.eventName,
          'beschreibung': '',
          'Start': payload.dateStart,
          'Ende': payload.dateEnd,
          'Mitarbeiter': payload.employeeId,
          'kat': payload.eventId,
          'sprache': payload.language,
          'action': 'Insert',
          'KAID': ''
        }
      })
      return response.data // Array<CalendarEventCategorize>
    },

    async [actionTypes.DELETE_CALENDAR_ART] ({ commit, state }, payload: DeleteCalendarEventPayload) {
      const response = await axios.post('/api/Planung', null, {
        params: {
          'Title': '',
          'beschreibung': '',
          'Start': payload.dateStart,
          'Ende': payload.dateEnd,
          'Mitarbeiter': payload.employeeId,
          'kat': '',
          'sprache': state.currentUser!.uiLanguage.syzId,
          'action': 'Delete',
          'KAID': payload.id
        }
      })
      return response.data
    },

    async [actionTypes.READ_MESSAGES_FROM_PLANNING] ({ commit, state }) {
      const response = await axios.get('/api/Planung')
      return response.data // Array<MessageModel>
    },

    async [actionTypes.SET_EMPLOYEE_PASSWORD] ({ commit, state }, payload: SetEmployeePasswordPayload) {
      const response = await axios.post('/api/CompanyStructure', null, {
        params: {
          'pwd': payload.password,
          'PWdIspossible': payload.changePassword,
          'Kurzeichen': payload.shortName,
          'sprache': state.currentUser!.uiLanguage.syzId
        }
      })
      return response
    },

    async [actionTypes.CHANGE_EMPLOYEE_PASSWORD] ({ commit, state }, payload: ChangeEmployeePasswordPayload): Promise<ResponseBase> {
      const response = await axios.get('/api/Employee/UpdatePassword', {
        params: {
          'ID': payload.id,
          'pwd': payload.password,
          'abv': payload.initials,
        }
      })
      return response.data
    },

    async [actionTypes.GET_COMPANY_SETTINGS] () {
      const response = await axios.get('/api/Configuration', {
        params: {
          'action': 'Read',
          'Primaerfarbe': '',
          'Sekundaerfarbe': '',
          'Wochenstarttag': '',
          'QualitaetZuKompetenzen': '',
          'QualitaetZuMitarbeiter': '',
          'PlanungMitAdresse': '',
          'ZeitmodellIndustrie': '',
          'Wochenzeitmodell': '',
          'SchichtnameVorschlagen': '',
          'NamensFormatStandard': '',
          'NachtschichtAnzeige': '',
          'PlanungAufProjekt': '',
          'DefWebreportTemplate': '',
          'LohnIntegration': '',
          'PlanungRaster': ''
        }
      })
      const data: Array<CompanySettingsResponse> = response.data

      return CompanySettings.createFromResponse(data)
    },

    async [actionTypes.CHANGE_COMPANY_SETTINGS] ({ commit, state }, payload: CompanySettingsPayload) {
      const response = await axios.get('/api/Configuration', {
        params: {
          'action': 'Update',
          'Primaerfarbe': payload.primaryColor,
          'Sekundaerfarbe': payload.secondaryColor,
          'Wochenstarttag': 'null',
          'QualitaetZuKompetenzen': payload.qualityByCompetences,
          'QualitaetZuMitarbeiter': payload.qualityByEmployee,
          'PlanungMitAdresse': payload.planningWithAddress,
          'ZeitmodellIndustrie': payload.planDaysPlanWeeksPlanYears,
          'Wochenzeitmodell': payload.weekTimeModel,
          'SchichtnameVorschlagen': payload.suggestShiftNamesFlag,
          'NamensFormatStandard': payload.nameFormat,
          'NachtschichtAnzeige': payload.nightShiftIndicator,
          'PlanungAufProjekt': payload.planungAufProjekt,
          'DefWebreportTemplate': payload.defWebreportTemplate,
          'LohnIntegration': payload.lohnIntegration,
          'PlanungRaster': payload.planungRaster
        }
      })
      return response.data
    },

    async [actionTypes.CHANGE_COMPANY_SETTINGS_WITH_WALLPAPER] ({ commit, state }, payload: CompanySettingsPayload) {
      const response = await axios.post('/api/Configuration',
        {
          "ImageIntroData": payload.wallpaper ? payload.wallpaper : '',
          "ImageIntroRemove": payload.isRemoveWallpaper,
          "LogoData": payload.logo ? payload.logo : '',
          'LogoRemove': payload.isRemoveLogo,
          'LogoUpdate': !!payload.logo || payload.isRemoveLogo,
          'FaviconData': payload.favicon ? payload.favicon : '',
          'FaviconRemove': payload.isRemoveFavicon,
          'FaviconUpdate': !!payload.favicon || payload.isRemoveFavicon
        }, {
        params: {
          'action': 'UpdateIntroImage',
          'Primaerfarbe': payload.primaryColor,
          'Sekundaerfarbe': payload.secondaryColor,
          'Wochenstarttag': 'null',
          'QualitaetZuKompetenzen': payload.qualityByCompetences,
          'QualitaetZuMitarbeiter': payload.qualityByEmployee,
          'PlanungMitAdresse': payload.planningWithAddress,
          'ZeitmodellIndustrie': payload.planDaysPlanWeeksPlanYears,
          'Wochenzeitmodell': payload.weekTimeModel,
          'SchichtnameVorschlagen': payload.suggestShiftNamesFlag,
          'NamensFormatStandard': payload.nameFormat,
          'NachtschichtAnzeige': payload.nightShiftIndicator,
          'PlanungAufProjekt': payload.planungAufProjekt,
          'DefWebreportTemplate': payload.defWebreportTemplate,
          'LohnIntegration': payload.lohnIntegration,
          'PlanungRaster': payload.planungRaster
        }
      })
      return response.data
    },

    async [actionTypes.LOAD_EMPLOYEE_TIME_MODEL] ({ commit, state }, payload: EmployeeTimeModelPayload) {
      const response = await axios.post('/api/Wochenzeitmodell?action=Grab&area=1&level=1', null, {
        data: {
          GueltigAb: payload.date,
          Name: payload.name,
          Mitarbeiter: payload.employee
        }
      })
      const data: SimpleWeekTimeModelResponse = response.data
      return SimpleWeekTimeModel.createListFromResponse(data)
    },

    async [actionTypes.LOAD_EMPLOYEE_COST_CENTER_MODEL] ({ commit, state }, payload: number) {
      const response = await axios.post('/api/Kostenstelle?action=Grab&kostenstellen=1', null, {
        params: {
          'mitarbeiter': payload
        }
      })
      const data: EmployeeCostCenterResponse = []
      response.data.forEach((item: EmployeeCostCenterResponseItem) => {
        if (state.selectedUiLanguage) {
          if (item.Sprache === state.selectedUiLanguage.syzId) {
            data.push(item)
          }
        }
      })
      return EmployeeCostCenter.createFromResponse(data)
    },

    async [actionTypes.INSERT_EDUCATION] ({ commit, state }, payload: EducationPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          Action: 'Insert',
          bildID: '',
          txtCode: payload.txtCode,
          txtGer: payload.txtGer,
          txtEng: payload.txtEng,
          txtFra: payload.txtFra,
          txtIta: payload.txtIta,
          txtPor: ''
        }
      })
      return response
    },

    async [actionTypes.UPDATE_EDUCATION] ({ commit, state }, payload: EducationPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          Action: 'Update',
          bildID: payload.educationId,
          txtCode: payload.txtCode,
          txtGer: payload.txtGer,
          txtEng: payload.txtEng,
          txtFra: payload.txtFra,
          txtIta: payload.txtIta,
          txtPor: ''
        }
      })
      return response
    },

    async [actionTypes.DELETE_EDUCATION] ({ commit, state }, payload: EducationPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          Action: 'Delete',
          bildID: payload.educationId,
          txtCode: payload.txtCode,
          txtGer: payload.txtGer,
          txtEng: payload.txtEng,
          txtFra: payload.txtFra,
          txtIta: payload.txtIta,
          txtPor: ''
        }
      })
      return response
    },

    async [actionTypes.INSERT_JOB] ({ commit, state }, payload: JobPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          ActionBerufe: 'Insert',
          bildID: payload.educationId,
          bildIDBerufe: '',
          txtCodeBerufe: payload.txtCode,
          txtGerBerufe: payload.txtGer,
          txtEngBerufe: payload.txtEng,
          txtFraBerufe: payload.txtFra,
          txtItaBerufe: payload.txtIta,
          txtPorBerufe: ''
        }
      })
      return response
    },

    async [actionTypes.UPDATE_JOB] ({ commit, state }, payload: JobPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          ActionBerufe: 'Update',
          bildID: payload.educationId,
          bildIDBerufe: payload.jobId,
          txtCodeBerufe: payload.txtCode,
          txtGerBerufe: payload.txtGer,
          txtEngBerufe: payload.txtEng,
          txtFraBerufe: payload.txtFra,
          txtItaBerufe: payload.txtIta,
          txtPorBerufe: ''
        }
      })
      return response
    },

    async [actionTypes.DELETE_JOB] ({ commit, state }, payload: JobPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          ActionBerufe: 'Delete',
          bildID: payload.educationId,
          bildIDBerufe: payload.jobId,
          txtCodeBerufe: payload.txtCode,
          txtGerBerufe: payload.txtGer,
          txtEngBerufe: payload.txtEng,
          txtFraBerufe: payload.txtFra,
          txtItaBerufe: payload.txtIta,
          txtPorBerufe: ''
        }
      })
      return response
    },

    async [actionTypes.INSERT_SPECIALIZATION] ({ commit, state }, payload: SpecializationPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          ActionFach: 'Insert',
          IDBerufe: payload.jobId,
          FachID: '',
          txtCodeFach: payload.txtCode,
          txtGerFach: payload.txtGer,
          txtEngFach: payload.txtEng,
          txtFraFach: payload.txtFra,
          txtItaFach: payload.txtIta,
          txtPorFach: ''
        }
      })
      return response
    },

    async [actionTypes.UPDATE_SPECIALIZATION] ({ commit, state }, payload: SpecializationPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          ActionFach: 'Update',
          IDBerufe: payload.jobId,
          FachID: payload.specializationId,
          txtCodeFach: payload.txtCode,
          txtGerFach: payload.txtGer,
          txtEngFach: payload.txtEng,
          txtFraFach: payload.txtFra,
          txtItaFach: payload.txtIta,
          txtPorFach: ''
        }
      })
      return response
    },

    async [actionTypes.DELETE_SPECIALIZATION] ({ commit, state }, payload: SpecializationPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          ActionFach: 'Delete',
          IDBerufe: payload.jobId,
          FachID: payload.specializationId,
          txtCodeFach: payload.txtCode,
          txtGerFach: payload.txtGer,
          txtEngFach: payload.txtEng,
          txtFraFach: payload.txtFra,
          txtItaFach: payload.txtIta,
          txtPorFach: ''
        }
      })
      return response
    },

    async [actionTypes.INSERT_DETAIL] ({ commit, state }, payload: DetailPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          ActionDetails: 'Insert',
          DetailsID: '',
          IDFach: payload.specializationId,
          txtCodeDetails: payload.txtCode,
          txtGerDetails: payload.txtGer,
          txtEngDetails: payload.txtEng,
          txtFraDetails: payload.txtFra,
          txtItaDetails: payload.txtIta,
          txtPorDetails: ''
        }
      })
      return response
    },

    async [actionTypes.UPDATE_DETAIL] ({ commit, state }, payload: DetailPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          ActionDetails: 'Update',
          DetailsID: payload.detailId,
          IDFach: payload.specializationId,
          txtCodeDetails: payload.txtCode,
          txtGerDetails: payload.txtGer,
          txtEngDetails: payload.txtEng,
          txtFraDetails: payload.txtFra,
          txtItaDetails: payload.txtIta,
          txtPorDetails: ''
        }
      })
      return response
    },

    async [actionTypes.DELETE_DETAIL] ({ commit, state }, payload: DetailPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          ActionDetails: 'Delete',
          DetailsID: payload.detailId,
          IDFach: payload.specializationId,
          txtCodeDetails: payload.txtCode,
          txtGerDetails: payload.txtGer,
          txtEngDetails: payload.txtEng,
          txtFraDetails: payload.txtFra,
          txtItaDetails: payload.txtIta,
          txtPorDetails: ''
        }
      })
      return response
    },

    async [actionTypes.INSERT_COMPETENCE] ({ commit, state }, payload: CompetencePayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          ActionC: 'Insert',
          IDC: '',
          txtCodeC: payload.txtCode,
          txtGerC: payload.txtGer,
          txtEngC: payload.txtEng,
          txtFraC: payload.txtFra,
          txtItaC: payload.txtIta,
          txtPorC: '',
        }
      })
      return response
    },

    async [actionTypes.UPDATE_COMPETENCE] ({ commit, state }, payload: CompetencePayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          ActionC: 'Update',
          IDC: payload.id,
          txtCodeC: payload.txtCode,
          txtGerC: payload.txtGer,
          txtEngC: payload.txtEng,
          txtFraC: payload.txtFra,
          txtItaC: payload.txtIta,
          txtPorC: '',
        }
      })
      return response
    },

    async [actionTypes.DELETE_COMPETENCE] ({ commit, state }, payload: CompetencePayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          ActionC: 'Delete',
          IDC: payload.id,
          txtCodeC: payload.txtCode,
          txtGerC: payload.txtGer,
          txtEngC: payload.txtEng,
          txtFraC: payload.txtFra,
          txtItaC: payload.txtIta,
          txtPorC: '',
        }
      })
      return response
    },

    async [actionTypes.LOAD_MASTER_DATA_QCQ_QUALITY] () {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          action: 'Read',
          QualitaetZuKompetenzen: '',
          QualitaetZuMitarbeiter: '',
          NumbersOfstars: '',
        }
      })
      //const data: QcqQualityResponse = response.data[0]
      return response.data[0] ? Quality.createFromQcqQualityResponse(response.data[0]) : undefined
    },

    async [actionTypes.EDIT_MASTER_DATA_QCQ_QUALITY] ({ commit, state }, payload: Quality) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          action: 'UpdateQuality',
          QualitaetZuKompetenzen: payload.competences,
          QualitaetZuMitarbeiter: payload.employees,
          NumbersOfstars: payload.numbersOfStars
        }
      })
      return response
    },

    async [actionTypes.LOAD_EMPLOYEE_QCQ_QUALIFICATION] ({ commit, state }, payload: number) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          'QualificationID': '',
          'MitarbeiterID': payload,
          'actionQualification': 'Grab',
          'BidungsgradeID': '',
          'BerufeID': '',
          'FachrichtungID': '',
          'DetailsID': '',
          'QualificationOldID': '',
          'Sprache': state.currentUser!.uiLanguage.syzId
        }
      })
      const data: EmployeeQcqQualificationResponse = response.data
      return EmployeeQcqQualification.createFromResponse(data)
    },

    async [actionTypes.LOAD_EMPLOYEE_QCQ_COMPETENCE] ({ commit, state }, payload: number) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          'CompetenceID': '',
          'MitarbeiterID': payload,
          'actionCompetence': 'Grab',
          'CompetenceOldID': '',
          'Quality': '',
          'Sprache': state.currentUser!.uiLanguage.syzId,
        }
      })
      const data: EmployeeQcqCompetenceResponse = response.data
      return EmployeeQcqCompetence.createFromResponse(data)
    },

    async [actionTypes.EDIT_EMPLOYEE_QCQ_COMPETENCE] ({ commit, state }, payload: EmployeeCompetencePayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          'CompetenceID': payload.competenceId,
          'MitarbeiterID': payload.employeeId,
          'actionCompetence': payload.action,
          'CompetenceOldID': payload.competenceOldId ? payload.competenceOldId : '',
          'Quality': payload.quality ? payload.quality : '',
          'Sprache': state.currentUser!.uiLanguage.syzId
        }
      })

      return response
    },

    async [actionTypes.LOAD_EMPLOYEE_QCQ_QUALITY] ({ commit, state }, payload: number) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          'NumbersOfStars': '',
          'MitarbeiterID': payload,
          'actionQuality': 'Grab',
        }
      })
      const data: EmployeeQcqQualityResponse = response.data
      return EmployeeQcqQuality.createFromResponse(data[0])
    },

    async [actionTypes.INSERT_EMPLOYEE_QCQ_QUALITY] ({ commit, state }, payload: EmployeeQualityPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          'NumbersOfStars': payload.numbersOfStars ? payload.numbersOfStars : 0,
          'MitarbeiterID': payload.employeeId,
          'actionQuality': 'Insert',
        }
      })
      return response
    },

    async [actionTypes.EDIT_EMPLOYEE_QCQ_QUALIFICATION] ({ commit, state }, payload: EmployeeQcqQualificationPayload) {
      const response = await axios.post('/api/QCQ', null, {
        params: {
          'QualificationID': payload.id ? payload.id : '',
          'MitarbeiterID': payload.employeeId,
          'actionQualification': payload.action,
          'BidungsgradeID': payload.educationId,
          'BerufeID': payload.jobId ? payload.jobId : '',
          'FachrichtungID': payload.specializationId ? payload.specializationId : '',
          'DetailsID': payload.detailsId ? payload.detailsId : '',
          'QualificationOldID': payload.id ? payload.id : '',
          'Sprache': state.currentUser!.uiLanguage.syzId
        }
      })
      return response
    },

    async [actionTypes.LOAD_REPORTS_LIST] ({ commit, state }, payload: number) {
      const response = await axios.get('/api/Report/GetReportList', {
        params: {
          languageId: state.selectedUiLanguage!.syzId,
          area: payload
        }
      })
      const data: ReportTreeItemResponse = response.data
      return ReportMenuTreeItem.createMenuFromResponse(data)
    },

    async [actionTypes.GENERATE_REPORT] ({ commit, state }, payload: GenerateReportPayload) {
      const response = await axios.post('/api/Report', {
        "Mitarbeiter": payload.employee,
        "Mitarbeiter_Label": payload.employeeLabel,
        "Abteilung": payload.department,
        "Abteilung_Label": payload.departmentLabel,
        "Filiale": payload.profitCenter,
        "Filiale_Label": payload.profitCenterLabel,
        "Filter": payload.filter,
        "Filter_Label": payload.filterLabel,
        "Jahr": payload.year,
        "Jahr_Label": payload.yearLabel,
        "Von": payload.from,
        "Von_Label": payload.fromLabel,
        "Bis": payload.to,
        "Bis_Label": payload.toLabel,
        "Farbe": payload.color,
        "Farbe_Label": payload.colorLabel,
        "KWdatumVon": payload.kwDatumVon,
        "KWdatumVon_Label": payload.kwDatumVonLabel,
        "Monat": payload.month,
        "Monat_Label": payload.monthLabel,
        "Schichten": payload.layers,
        "Schichten_Label": payload.layersLabel,
        "Grund": payload.absencReason,
        "Grund_Label": payload.absencReasonLabel,
        "Adresse": payload.address,
        "Adresse_Label": payload.addressLabel,
        "Planungsgruppe": payload.planningGroup,
        "Planungsgruppe_Label": payload.planningGroupLabel,
        "SendTo": payload.sendTo,
        "SendTo_Label": payload.sendToLabel,
        "Datum": payload.date,
        "Datum_Label": payload.dateLabel
      },{
        params: {
          'generateReport': payload.reportLayout,
          'reportName': payload.reportName,
          'sendEmail': payload.sendEmail,
          'format': payload.format
        },
        responseType: payload.sendEmail ? 'json' : 'arraybuffer'
      })
      return response
    },

    async [actionTypes.GENERATE_MULTI_REPORT] ({ commit, state }, payload: MultiReportPayload): Promise<any> {
      payload.LanguageId = state.selectedUiLanguage!.syzId
      const response = await axios.post('/api/Report/GenerateAndMergeReports', payload,{
        responseType: payload.SendByEmail ? 'json' : 'arraybuffer'
      })
      return response
    },

    async [actionTypes.LOAD_DATES_BY_YEAR] ({ commit, state }, payload: string) {
      const response = await axios.get('/api/Report', {
        params: {
          year: payload
        }
      })
      const data: any = response.data
      return data
    },

    async [actionTypes.FETCH_EMPLOYEE_PHOTO] ({ commit, state }, payload: string) {
      const response = await axios.get('/api/CompanyStructure', {
        params: {
          'loadUserPhoto': payload
        },
        responseType: 'arraybuffer'
      })

      let image = btoa(
        new Uint8Array(response.data)
          .reduce((data, byte) => data + String.fromCharCode(byte), '')
      );
      return `data:${response.headers['content-type'].toLowerCase()};base64,${image}`
    },

    async [actionTypes.FETCH_EMPLOYEE_BY_ID] ({ commit, state }, payload: number): Promise<GetEmployeeResponse> {
      const response = await axios.get('/api/Employee/Get',
        {
          params: {
            'employeeId': payload
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_EMPLOYEE_METADATA] ({ commit, state }): Promise<EmployeeMetadataResponse> {
      const response = await axios.get('/api/Automatic/GetMultipleWithMetadata',
        {
          params: {
            'sp': 'Mitarbeiter_GetLists',
            'i_Sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.UPSERT_EMPLOYEE] ({ commit, state }, payload: UpsertMitarbeiterRequest): Promise<any> {
      const response = await axios.post('/api/Mitarbeiter/UpsertMitarbeiter', payload)
      return response.data
    },

    async [actionTypes.UPSERT_EMPLOYEE_CONTACTS] ({ commit, state }, payload: UpsertMitarbeiterKontaktinfosRequest): Promise<any> {
      const response = await axios.post('/api/Mitarbeiter/UpsertMitarbeiterKontaktinfos', payload)
      return response.data
    },

    async [actionTypes.CHANGE_EMPLOYEE_DATA] ({ commit, state }, payload: EmployeeDataPayload): Promise<UpdateEmployeeResponse> {
      const response = await axios.post('/api/CompanyStructure',
        {
          'PhotoData': payload.photoData,
          'PhotoRemove': payload.photoRemove,
          'PhotoUpdate': payload.photoUpdate,
          'AbteilungAll': payload.allDepartments,
          'Abteilung': payload.floaterDepartments,
          'Lernender': payload.isApprentice,
          'SchuleIn': payload.schoolIn ? payload.schoolIn : null,
          'SYZInTimeAktiv': payload.SYZInTimeAktiv,
          'MailGeschaft': payload.businessEmail
        }, {
          params: {
            'id': payload.id,
            'planbar': payload.isPlanable ? payload.isPlanable : false,
            'springer': payload.isFloater ? payload.isFloater : false,
            'Stellung': payload.position ? payload.position : '',
            'Planungsgruppe': payload.planningGroupId ? payload.planningGroupId : '',
            'Stellvertretung': payload.replacementOfEmployeeId ? payload.replacementOfEmployeeId : '',
            'Vorgesetzter': payload.supervisorId ? payload.supervisorId : '',
            'Nickname': payload.nickName ? payload.nickName : '',
            'Sprache': payload.preferredLanguageId,
            'Kurzzeichen': payload.shortName
          }
        }
      )
      return response.data
    },

    async [actionTypes.FETCH_VERSION] ({ commit, state }) {
      const response = await axios.get('/api/Version')
      return response.data
    },

    async [actionTypes.FIX_PROJECT_SERIE] ({ commit, state }, payload: Array<number>): Promise<ResponseBase> {
      const response = await axios.post('/api/Planung/FixiertProjectList',
        {
          ProjectIds: payload
        })
      return response.data
    },

    async [actionTypes.SCHEDULER_AUTO_PLANNING] ({ commit, state }, payload: SchedulerAutoPlanningPayload) : Promise<boolean> {
      const response = await axios.post('/api/Planung',
        {
          "SerieIDs": payload.projectSerieList,
          "DatumStart": payload.startDate,
          "DatumEnd": payload.endDate,
          "Sprache": state.selectedUiLanguage!.syzId
        },
        {
          params: {
            'autoPlanningPeriods': ''
          }
        })
      return response.data
    },

    async [actionTypes.DELETE_CHECKED_LIST] ({ commit, state }, payload: Array<number>) {
      const response = await axios.post('/api/PlanungActions',
        payload,
        {
          params: {
            'ShiftsDelete': 1
          }
        })
      return response.data // boolean
    },

    async [actionTypes.FETCH_EMPLOYEE_HIERARCHY_LIST] ({ commit, state }, payload: EmployeeHierarchyPayload) {
      const response = await axios.get('/api/Configuration',
        {
          params: {
            'abteilung': payload.departmentId,
            'planungsGruppe': payload.planningGroupId,
            'loadPositionMitarbeiter': ''
          }
        })
      return EmployeeHierarchyList.createListFromResponse(response.data)
    },

    async [actionTypes.UPDATE_EMPLOYEE_HIERARCHY_LIST] ({ commit, state }, payload: EmployeeHierarchyPayload) {
      const response = await axios.post('/api/Configuration',
        payload.sortedEmployees,
        {
          params: {
            'abteilung': payload.departmentId,
            'planungsGruppe': payload.planningGroupId,
            'savePositionMitarbeiter': ''
          }
        })
      return EmployeeHierarchyList.createListFromResponse(response.data)
    },

    async [actionTypes.FETCH_EMAIL_TEMPLATE_METADATA] () {
      const response = await axios.get('/api/Automatic/GetMultipleWithMetadata',
        {
          params: {
            'sp': 'EMailTemplate_GetLists',
            'i_Sprache': state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_EMAIL_TEMPLATE_LIST] () {
      const response = await axios.get('/api/Configuration',
        {
          params: {
            'loadEmailTemplates': ''
          }
        })
      return EmailTemplate.createListFromResponse(response.data)
    },

    async [actionTypes.SAVE_EMAIL_TEMPLATE] ({ commit, state }, payload: EmailTemplate): Promise<boolean> {
      const response = await axios.post('/api/Configuration',
        {
          'ID': payload.id,
          'EMailTemplateGruppe': payload.eMailTemplateGruppe,
          'EMailTemplateType': payload.eMailTemplateType,
          'Sprache': payload.sprache,
          'Bezeichnung': payload.bezeichnung,
          'HTML': payload.HTML,
          'Subject': payload.subject,
          'Body': payload.body
        },
        {
          params: {
            'saveTemplate': ''
          }
        })
      return response.data
    },

    async [actionTypes.LOAD_EMAIL_SMTP_SETTINGS] () {
      const response = await axios.get('/api/Configuration',
        {
          params: {
            'loadEmailSmtpSettings': ''
          }
        })

      return EmailSmtpSettings.createListFromResponse(response.data)
    },

    async [actionTypes.SAVE_EMAIL_SMTP_SETTINGS] ({ commit, state }, payload: EmailSmtpSettings): Promise<boolean> {
      const response = await axios.post('/api/Configuration',
        {
          'Login': payload.login,
          'Password': payload.password,
          'Host': payload.host,
          'Port': payload.port,
          'Title': payload.title,
          'UseSsl': payload.useSsl,
          'SenderEmail': payload.senderEmail
        },
        {
          params: {
            'saveEmailSettings': ''
          }
        })
      return response.data
    },

    async [actionTypes.GET_LOAD_INTRO_DATA] ({ commit, state }): Promise<any> {
      const response = await axios.get('/api/Configuration',
        {
          params: {
            'loadIntroData': ''
          }
        })

      commit(mutationTypes.SET_IS_CAPELO_MUTATION, response.data.Capelo)
      return response.data
    },

    async [actionTypes.SEARCH_ADDRESS_LIST] ({ commit, state }, payload: string): Promise<any> {
      const response = await axios.get('/api/CompanyStructure',
        {
          params: {
            'searchAddresse': payload
          }
        })

      if(response.data.length > 0) {
        return Address.createListFromResponse(response.data)
      } else {
        return []
      }
    },

    async [actionTypes.SEARCH_ADDRESS_BY_ID] ({ commit, state }, payload: number): Promise<Address[]> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'loadAddresse': payload
          }
        })

      if(response.data.length > 0) {
        return Address.createListFromResponse(response.data)
      } else {
        return []
      }
    },

    async [actionTypes.FETCH_ADDRESS_GROUP] (): Promise<Array<AddressGroup>> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'AdressGroupeData': ''
          }
        })

      return AddressGroup.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_ADDRESS_LIST] ({ commit, state }, payload: string): Promise<any> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'groupId': payload
          }
        })

      return AddressSidebarItem.createFromResponse(response.data)
    },

    async [actionTypes.SEARCH_ADDRESS] ({ commit, state }, payload: string): Promise<any> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'searchAddresse': payload
          }
        })

      return AddressSidebarItem.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_SALUTATION] (): Promise<any> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'AnredenData': ''
          }
        })

      return Salutation.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_TITLE_LIST] (): Promise<any> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'TitelData': ''
          }
        })

      return Title.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_LAND_LIST] (): Promise<any> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'LaenderData': ''
          }
        })

      return Land.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_FUNCTION_LIST] (): Promise<any> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'FunktionData': ''
          }
        })

      return EmployeeFunction.createFromResponse(response.data)
    },

    async [actionTypes.CREATE_ADDRESS] ({ commit, state }, payload: AddressPayload): Promise<any> {
      const response = await axios.post('/api/Adressen/',
        {
          "ID": payload.data.id ? payload.data.id : '',
          'Sprache': payload.data.language ? payload.data.language : 1,
          'AdressNummer': payload.data.addressNumber,
          'Sortierung': payload.data.sorting,
          'Name': payload.data.name,
          'Land': payload.data.land ? payload.data.land : 1,
          'AdressGruppe': payload.data.addressGroup,
          'Anrede': payload.data.selectedSalutation,
          'Titel': payload.data.selectedTitle,
          'Vorname': payload.data.firstName,
          'Zusatz': payload.data.addition,
          'Strasse': payload.data.street,
          'Hausnummer': payload.data.houseNumber,
          'Postfach': payload.data.pobox,
          'PLZ': payload.data.postcode,
          'Ort': payload.data.city,
          'Region': payload.data.region,
          'Telefongeschaeftlich': payload.data.businessPhone,
          'Telefonprivat': payload.data.privatePhone,
          'Handygeschaeftlich': payload.data.businessMobile,
          'Mailgeschaeftlich': payload.data.businessMail,
          "Mailprivat": payload.data.privateMail,
          'Homepage': payload.data.webPage,
          'Handyprivat': payload.data.privateMobile,
          'Beschreibung': payload.data.description,
          'Aktiv': payload.data.active,
          'PrivatAdresse': payload.data.privateAddress,
          'Farbe': payload.data.color,
          'GeoLAT': payload.data.geoLat,
          'GeoLON': payload.data.geoLon
        },
        {
          params: {
            'AdressenData': '',
            'Action': payload.action
          }
        })
      return response.data
    },

    async [actionTypes.FETCH_ADDRESS_DETAIL] ({ commit, state }, payload: number): Promise<any> {
      const response = await axios.get('/api/Adressen/',
        {
          params: {
            'AdressDetailData': payload
          }
        })

      return AddressDetail.createFromResponse(response.data)
    },

    async [actionTypes.CREATE_ADDRESS_EMPLOYEE] ({ commit, state }, payload: AddressEmployeePayload): Promise<any> {
      const response = await axios.post('/api/Adressen/',
        {
          "Adresse": payload.data.address,
          "PrivatAdresse": payload.data.privatAddress,
          "Name": payload.data.name,
          "Vorname": payload.data.firstName,
          "Sprache": payload.data.language,
          "Titel": payload.data.title,
          "Anrede": payload.data.salutation,
          "Beschreibung": payload.data.description,
          "Zusatz": payload.data.addition,
          "IDMarker": payload.data.idMarker ? payload.data.idMarker : '',
          "MDT": payload.data.mdt ? payload.data.mdt : '',
          "Abteilung": payload.data.department,
          "Vorgesetzter": payload.data.supervisor,
          "Buero": payload.data.office,
          "Assistent": payload.data.assistant,
          "Beruf": payload.data.job,
          "Spitzname": payload.data.nickname,
          "Partner": payload.data.partner,
          "Geburtsdatum": payload.data.dateOfBirth,
          "Jahrestag": payload.data.anniversary,
          "Kinder": payload.data.children,
          "Aktiv": payload.data.active,
          "FIBUrelevant": payload.data.financeRelevance,
          "Funktion": payload.data.position,
          "Telefongeschaeftlich": payload.data.businessPhone,
          "Telefonprivat": payload.data.privatePhone,
          "Handygeschaeftlich": payload.data.businessMobile,
          "Handyprivat": payload.data.privateMobile,
          "Mailgeschaeftlich": payload.data.businessMail,
          "Mailprivat": payload.data.privateMail,
          "GenAdresse": payload.data.genAddress,
          "ID": payload.data.id
        },
        {
          params: {
            'SachbearbeiterData': '',
            'Action': payload.action
          }
        })
      return response.data
    },

    async [actionTypes.FETCH_ADDRESS_COLOR_LIST] (): Promise<AddressColor[]> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'FarbenData': ''
          }
        })

      return AddressColor.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_ADDRESS_POST_CODE_DATA] ({ commit, state }, payload: PostCodeDataPayload): Promise<GetOrtPlzResponse> {
      const response = await axios.get('/api/Adressen/GetOrtPlz',
        {
          params: {
            'land': payload.land,
            'plz': payload.plz
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_ADDRESS_FELD_LIST] ({ commit, state }): Promise<AdressZusatzfelderTypesResponse[]> {
      const response = await axios.get('/api/Project/GetAdressZusatzfelderList',
        {
          params: {
            'languageId': state.currentUser!.uiLanguage.syzId,
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_ADDRESS_CONTACT_LIST] ({ commit, state }, payload: number): Promise<GetContactListResponse[]> {
      const response = await axios.get('/api/ContactInfo/GetContactListByAddressId',
        {
          params: {
            'addressId': payload,
            'languageId': state.currentUser!.uiLanguage.syzId,
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_EMPLOYEE_CONTACT_LIST] ({ commit, state }, payload: number): Promise<GetContactListResponse[]> {
      const response = await axios.get('/api/ContactInfo/GetContactListByEmployeeId',
        {
          params: {
            'employeeId': payload,
            'languageId': state.currentUser!.uiLanguage.syzId,
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_AGENCY_LIST] ({ commit, state }): Promise<AgencyResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            'sp': 'Adressen_GetAgencyList'
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_ADDRESS_ADDITIONAL] ({ commit, state }, payload: number): Promise<any> {
      const response = await axios.get('/api/Zusatzfelder',
        {
          params: {
            'Sprache': state.currentUser!.uiLanguage.syzId,
            'Adresse': payload
          }
        })

      return AdditionalGroup.createFromResponse(response.data)
    },

    async [actionTypes.SAVE_ADDRESS_ADDITIONAL] ({ commit, state }, payload: AdditionalFieldsPayload, ): Promise<boolean> {
      const response = await axios.post('/api/Zusatzfelder', payload.fields,
        {
          params: {
            'Adresse': payload.addressId
          }
        })
      return response.data
    },

    async [actionTypes.FETCH_ADDRESS_FUNCTION_LIST] ({ commit, state }): Promise<AddressFunction[]> {
      const response: AxiosResponse = await axios.get('/api/Adressen/',
        {
          params: {
            'VerantwortungsData': '',
          }
        })

      return AddressFunction.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_ADDRESS_RESPONSIBLE_EMPLOYEE_LIST] ({ commit, state }, payload: number): Promise<VerantwortungsDataResponse> {
      const response: AxiosResponse = await axios.get('/api/Adressen/GetVerantwortungsData',
        {
          params: {
            'adresse': payload,
            'sprache': state.currentUser!.uiLanguage.syzId,
          }
        })

      return response.data
    },

    async [actionTypes.ADDRESS_RESPONSIBLE_EMPLOYEE] ({ commit, state }, payload: UpdateVerantwortungsDataRequest ): Promise<ResponseBase> {
      const response = await axios.post('/api/Adressen/UpdateVerantwortungsData',payload)
      return response.data
    },

    async [actionTypes.FETCH_NOTES] ({ commit, state }, payload: number ): Promise<Note[]> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            NotizenDetailsData: payload,
            Sprache: state.selectedUiLanguage!.syzId
          }
        })
      return Note.createFromResponse(response.data)
    },

    async [actionTypes.SAVE_NOTE] ({ commit, state }, payload: NotePayload ): Promise<AdressenNotizenIndexResponse> {
      const response = await axios.post('/api/Adressen',
        {
          ID: payload.id ? payload.id : null,
          Adresse: payload.addressId,
          Sachbearbeiter: payload.selectedAddressEmployeeName,
          NotizArt: payload.noteType,
          Titel: payload.noteTitle,
          Beschreibung: payload.noteText,
          Verantwortlich: payload.selectedResponsibleEmployee,
          Beginn: payload.dateStartIso,
          Faellig: payload.dateEndIso,
          Erledigt: payload.alreadyDone,
          IDMarker: null,
          MDT: null,
          ErstelltVon: null,
          BeschreibungRTF: null,
          Privat: payload.isPrivate,
          SachbearbeiterID: payload.selectedAddressEmployeeId,
          Author: payload.selectedAuthor,
          Produkt: null,
          Projekt: null,
          Herkunft: 0,
          Kommission: null,
          Projektdetail: null,
        },
        {
          params: {
            'AdressenNotizenData': payload.addressId,
            'Action': payload.action
          }
        })
      return response.data
    },

    async [actionTypes.FETCH_NOTES_TYPE_LIST] (): Promise<NoteType[]> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            NotizArt: '',
            Sprache: state.selectedUiLanguage!.syzId
          }
        })

      return NoteType.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_NOTE_ATTACHMENT_LIST] ({ commit, state }, payload: number ): Promise<GetNoteAttachmentListResponse> {
      const response = await axios.get('/api/AddressNote/GetNoteAttachmentList',
        {
          params: {
            noteId: payload
          }
        })
      return response.data
    },

    async [actionTypes.FETCH_NOTE_ATTACHMENT_BY_ID] ({ commit, state }, payload: number ): Promise<any> {
      const response = await axios.get('/api/AddressNote/GetAttachmentById',
        {
          responseType: 'blob',
          params: {
            attachmentId: payload
          }
        })
      return response.data
    },

    async [actionTypes.SAVE_NOTE_ATTACHMENT] ({ commit, state }, payload: SaveNoteAttachmentPayload ): Promise<SaveNoteAttachmentResponse> {
      const response = await axios.post('/api/AddressNote/SaveNoteAttachment', payload )
      return response.data
    },

    async [actionTypes.DELETE_NOTE_ATTACHMENT] ({ commit, state }, payload: number ): Promise<DeleteNoteAttachmentResponse > {
      const response = await axios.get('/api/AddressNote/DeleteNoteAttachment',
        {
          params: {
            attachmentId: payload
          }
        })
      return response.data
    },

    async [actionTypes.FETCH_VERSIONS] ({ commit, state }): Promise<Version> {
      const frontendVersion: string = process.env.VUE_APP_VERSION as string
      const response = await axios.post('/api/Version', null,
        {
          params: {
            'frontend': frontendVersion
          }
        })

      const version: Version = Version.createFromResponse(response.data)

      commit(mutationTypes.SET_VERSION, version)
      return version
    },

    async [actionTypes.FETCH_INFORMATION_DATA] ({ commit, state }): Promise<Changelog[]> {
      const response = await axios.get('/api/Version',
        {
          params: {
            'changelog': ''
          }
        })

      return Changelog.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_STATISTIC_DATA] ({ commit, state }, payload: MonthStatisticPayload): Promise<MonthStatistic[]> {
      const response = await axios.get('/api/Planung',
        {
          params: {
            'year': payload.year,
            'month': payload.month,
            'abteilung': payload.department
          }
        })

      return MonthStatistic.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_DISPOSITION_JOB_LIST] ({ commit, state }, payload: boolean): Promise<DispositionJob[]> {
      const response = await axios.get('/api/PersonalDispo',
        {
          params: {
            'PersonalDispoLaeufeData': '',
            'reallocation': payload
          }
        })
      return DispositionJob.createFromResponse(response.data)
    },

    async [actionTypes.SAVE_DISPOSITION_JOB_DATA] ({ commit, state }, payload: DispositionJobPayload ): Promise<number> {
      const requirements: any = payload.requirements.map((item: any) => {
        return {Kompetenz: item.id}
      })
      const response = await axios.post('/api/PersonalDispo',
        {
          ID: payload.id,
          Sprache: state.selectedUiLanguage!.syzId,
          Adresse: payload.address,
          Wiederholung: payload.workRhythm,
          MontagVM: payload.workFormData[0].morning,
          MontagNM: payload.workFormData[0].afternoon,
          MontagPrio: parseInt(payload.workFormData[0].priority),
          DienstagVM: payload.workFormData[1].morning,
          DienstagNM: payload.workFormData[1].afternoon,
          DienstagPrio: parseInt(payload.workFormData[1].priority),
          MittwochVM: payload.workFormData[2].morning,
          MittwochNM: payload.workFormData[2].afternoon,
          MittwochPrio: parseInt(payload.workFormData[2].priority),
          DonnerstagVM: payload.workFormData[3].morning,
          DonnerstagNM: payload.workFormData[3].afternoon,
          DonnerstagPrio: parseInt(payload.workFormData[3].priority),
          FreitagVM: payload.workFormData[4].morning,
          FreitagNM: payload.workFormData[4].afternoon,
          FreitagPrio: parseInt(payload.workFormData[4].priority),
          SamstagVM: payload.workFormData[5].morning,
          SamstagNM: payload.workFormData[5].afternoon,
          SamstagPrio: parseInt(payload.workFormData[5].priority),
          SonntagVM: payload.workFormData[6].morning,
          SonntagNM: payload.workFormData[6].afternoon,
          SonntagPrio: parseInt(payload.workFormData[6].priority),
          ReferenzTermin: payload.referenceDate,
          BasisStd: payload.basicHours,
          ZusatzStd: payload.additionalHours,
          TotalStd: payload.totalHours,
          UmkreisVon: payload.employeeInDistance,
          IDMarker: null,
          MDT: null,
          Vorgaben: requirements,
          Reallocation: payload.reallocation
        },
        {
          params: {
            'PersonalDispoJobsData': '',
            'Action': payload.action
          }
        })
      return response.data
    },

    async [actionTypes.GET_DISPOSITION_JOB_DATA] ({ commit, state }, payload: number ): Promise<DispositionJobDetail | undefined> {
      const response = await axios.post('/api/PersonalDispo',
        {
          ID: payload,
          Sprache: state.selectedUiLanguage!.syzId
        },
        {
          params: {
            'PersonalDispoJobsData': '',
            'Action': 'GetDetail'
          }
        })
     return DispositionJobDetail.createFromResponse(response.data)
    },

    async [actionTypes.DELETE_DISPOSITION_JOB] ({ commit, state }, payload: number ): Promise<boolean> {
      const response = await axios.post('/api/PersonalDispo',
        {
          ID: payload
        },
        {
          params: {
            'PersonalDispoJobsData': '',
            'Action': 'Delete'
          }
        })
      return response.data
    },

    async [actionTypes.FETCH_DISPOSITION_ADDRESS_LIST] ({ commit, state }): Promise<DispositionAddress[]> {
      const response = await axios.get('/api/PersonalDispo',
        {
          params: {
            'AddressNewPF': ''
          }
        })

      return DispositionAddress.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_DISPOSITION_REALLOCATION_ADDRESS_LIST] ({ commit, state }): Promise<DispositionAddress[]> {
      const response = await axios.get('/api/PersonalDispo',
        {
          params: {
            'AddressExistingPF': ''
          }
        })

      return DispositionAddress.createFromResponse(response.data)
    },

    async [actionTypes.FIND_PERSON_FOR_DISPOSITION_JOB] ({ commit, state }, payload: FindPersonDispoJobPayload ): Promise<boolean> {
      const response = await axios.post('/api/PersonalDispo',
        null,
        {
          params: {
            'FindPersonForDispoJob': payload.id,
            'reallocation': payload.reAllocation
          }
        })

      return response.data
    },

    async [actionTypes.UPDATE_DISPOSITION_JOB_PERSON_LIST] ({ commit, state }, payload: DispositionJobEmployee[] ): Promise<boolean> {
      const data = payload.map((item: DispositionJobEmployee) => {
        return {
          ID: item.id,
          Status: item.status,
          Notiz: item.note
        }
      })

      const response = await axios.post('/api/PersonalDispo',
        data,
        {
          params: {
            'PersonalDispoLaeufeDetailsIndex': '',
          }
        })

      return response.data
    },

    async [actionTypes.ASSIGN_EMPLOYEE_TO_DISPOSITION_JOB] ({ commit, state }, payload: number ): Promise<boolean> {
      const response = await axios.post('/api/PersonalDispo',
        {
          ID: payload,
          Sprache: state.selectedUiLanguage!.syzId
        },
        {
          params: {
            'PersonalDispoJobsData': '',
            'Action': 'AddPerson'
          }
        })

      return response.data
    },

    async [actionTypes.ASSIGN_EMPLOYEE_TO_DISPOSITION_JOB_REALLOCATION] ({ commit, state }, payload: number ): Promise<boolean> {
      const response = await axios.post('/api/PersonalDispo',
        {
          ID: payload,
          Reallocation: true,
          Sprache: state.selectedUiLanguage!.syzId
        },
        {
          params: {
            'PersonalDispoJobsData': '',
            'Action': 'AddPerson'
          }
        })

      return response.data
    },

    async [actionTypes.END_DISPOSITION_JOB] ({ commit, state }, payload: number ): Promise<boolean> {
      const response = await axios.post('/api/PersonalDispo',
        {
          ID: payload,
          Sprache: state.selectedUiLanguage!.syzId
        },
        {
          params: {
            'PersonalDispoJobsData': '',
            'Action': 'DispolaufExit'
          }
        })

      return response.data
    },

    async [actionTypes.SET_DISPOSITION_JOB_STATUS_LIST] ({ commit, state }, payload: DispositionJobStatus): Promise<void> {
      commit(mutationTypes.SET_DISPOSITION_JOB_STATUS_LIST_MUTATION, payload)
    },

    async [actionTypes.FETCH_DISPOSITION_WEEK_PERIOD_LIST] (): Promise<WorkRhythm[]> {
      const response = await axios.get('/api/PersonalDispo',
        {
          params: {
            'WeekPeriodData': ''
          }
        })

      return WorkRhythm.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_SUBSTITUTION_LIST] ({ commit, state }, payload: number): Promise<Substitution[]> {
      const response = await axios.get('/api/PersonalDispo',
        {
          params: {
            'STVListDataRows': '',
            'Aktiv': payload,
            'Language': state.selectedUiLanguage!.syzId
          }
        })

      return Substitution.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_REPLACEMENT_DISPOSITION_LIST] ({ commit, state }, payload: boolean): Promise<ReplacementDispositionResponse> {
      const response = await axios.get('/api/PersonalDispo/GetReplacementDispositionList',
        {
          params: {
            'active': payload
          }
        })
      return response.data
    },

    async [actionTypes.FETCH_REPLACEMENT_LIST] ({ commit, state }, payload: Replacement): Promise<ReplacementListResponse> {
      const response = await axios.get('/api/PersonalDispo/GetReplacementList',
        {
          params: {
            'absenceId': payload.absenceId,
            'addressNumber': payload.addressNumber
          }
        })

      return response.data
    },

    async [actionTypes.UPDATE_REPLACEMENTS] ({ commit, state }, payload: ReplacementPayload[]): Promise<UpdateReplacementListResponse> {
      const response = await axios.post('/api/PersonalDispo/UpdateReplacements', {Data: payload})

      return response.data
    },

    async [actionTypes.SAVE_REPLACEMENT_DETAILS] ({ commit, state }, payload: ReplacementDetailsPayload): Promise<SaveReplacementDetailsResponse> {
      const response = await axios.post('/api/PersonalDispo/SaveReplacementsDetails', payload)

      return response.data
    },

    async [actionTypes.FETCH_REPLACEMENTS_DETAILS] ({ commit, state }, payload: Replacement): Promise<SaveReplacementDetailsResponse> {
      const response = await axios.get('/api/PersonalDispo/GetReplacementsDetails',
        {
          params: {
            'absenceId': payload.absenceId,
            'addressNumber': payload.addressNumber
          }
        })

      return response.data
    },

    async [actionTypes.UPDATE_REPLACEMENT_PERSON_LIST] ({ commit, state }, payload: ReplacementPersonListPayload ): Promise<UpdateReplacementPersonListResponse> {
      const response = await axios.post('/api/PersonalDispo/SaveStatusAndNotiz', {Items: payload})

      return response.data
    },

    async [actionTypes.ASSIGN_EMPLOYEE_TO_REPLACEMENT] ({ commit, state }, payload: AssignEmployeeToReplacementPayload ): Promise<AssignReplacementResponse> {
      const response = await axios.post('/api/PersonalDispo/AssignEmployeeToReplacement',
        null,
        {
          params: payload
        })

      return response.data
    },

    async [actionTypes.FINISH_REPLACEMENT] ({ commit, state }, payload: number ): Promise<FinishReplacementResponse> {
      const response = await axios.post('/api/PersonalDispo/SetReplacementComplete',
        null,
        {
          params: {
            'detailsId': payload
          }
        })

      return response.data
    },

    async [actionTypes.SUBSTITUTION_START_PROCESSING] ({ commit, state }, payload: SelectedSubstitutionPayload[] ): Promise<boolean> {
      const response = await axios.post('/api/PersonalDispo', payload,
        {
          params: {
            'sendEmail': '',
          }
        })

      return response.data
    },

    async [actionTypes.CHANGE_SUBSTITUTION_STATUS] ({ commit, state }, payload: any ): Promise<boolean> {
      const response = await axios.post('/api/PersonalDispo', payload.data,
        {
          params: {
            'actionButton': payload.action,
          }
        })

      return response.data
    },

    async [actionTypes.SAVE_SHIFT_ADDRESS_EMPLOYEE_NOTE] ({ commit, state }, payload: any ): Promise<boolean> {

      let params = undefined

      if(payload.action === NoteEditMenu.Shift) {
        params = {
          NoteSchicht: '',
          ProjektSchichtID: payload.id
        }
      } else if(payload.action === NoteEditMenu.Address) {
        params = {
          NoteAdress: '',
          AdressNummer: payload.id,
          NoteDate: payload.date,
          MitarbeiterID: payload.employeeId
        }
      } else if(payload.action === NoteEditMenu.Employee) {
        params = {
          NoteMitarbeiter: '',
          MitarbeiterID: payload.id
        }
      }

      if(params) {
        const response = await axios.post('/api/Note',
          {
            note: payload.note
          },
          {
            params: params
          })

        return response.data
      } else {
        return false
      }
    },

    async [actionTypes.FETCH_EMPLOYEE_NOTE] ({ commit, state }, payload: number ): Promise<string> {
      const response = await axios.get('/api/Note',
        {
          params: {
            'NoteMitarbeiter': '',
            'MitarbeiterID': payload
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_ADDRESS_NOTE] ({ commit, state }, payload: AddressNotePayload ): Promise<AddressNoteResponse> {
      const response = await axios.get('/api/Note/GetAdress',
        {
          params: {
            'adressNummer': payload.id,
            'noteDate': payload.date
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_SHIFT_NOTE] ({ commit, state }, payload: number ): Promise<string> {
      const response = await axios.get('/api/Note',
        {
          params: {
            'NoteSchicht': '',
            'ProjektSchichtID': payload
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_SHIFT_TOOLTIP] ({ commit, state }, payload: number ): Promise<NoteTooltip> {
      const response = await axios.get('/api/Note/GetNote',
        {
          params: {
            'projektSchichtID': payload,
            'sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return NoteTooltip.createFromResponse(response.data.Tooltip)
    },

    async [actionTypes.FETCH_ABSENCE_TOOLTIP] ({ commit, state }, payload: number ): Promise<any> {
      const response = await axios.get('/api/Note/GetNoteAbsence',
        {
          params: {
            'absenceId': payload,
            'sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_CALENDAR_ART_TOOLTIP] ({ commit, state }, payload: number ): Promise<any> {
      const response = await axios.get('/api/Note/GetNoteKalendarArt',
        {
          params: {
            'kaId': payload,
            'sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_SCHEDULER_SETTINGS] (): Promise<SchedulerSettings[]> {
      const response = await axios.get('/api/PlanungActions',
        {
          params: {
            'SettingsList': ''
          }
        })

      return SchedulerSettings.createListFromResponse(response.data)
    },

    async [actionTypes.SAVE_SCHEDULER_SETTINGS] ({ commit, state }, payload: SchedulerSettings ): Promise<void> {
      await axios.post('/api/PlanungActions',
        {
          Code: payload.code,
          SettingValue: payload.value ? '1' : '0',
          Bezeichnung : payload.description
        },
        {
          params: {
            'SettingsData': '',
          }
        })
    },

    async [actionTypes.SEARCH_ADDRESSLINIE_LIST] ({ commit, state }, payload: string): Promise<any> {
      const response = await axios.get('/api/CompanyStructure',
        {
          params: {
            'LinieSearch': payload
          }
        })

      if(response.data.length > 0) {
        return Address.createListFromResponse(response.data)
      } else {
        return []
      }
    },

    async [actionTypes.FETCH_ADDITIONAL_SERVICES_PRODUCT_LIST] (): Promise<AdditionalServicesProduct[]> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'getListProducts': '',
            'sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return AdditionalServicesProduct.createListFromResponse(response.data)
    },

    async [actionTypes.FETCH_ADDITIONAL_SERVICES_CURRENCY_LIST] (): Promise<Currency[]> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'Waehrungen': ''
          }
        })

      return Currency.createListFromResponse(response.data)
    },

    async [actionTypes.FETCH_ADDITIONAL_SERVICES_PROVISION_LIST] (): Promise<AdditionalServicesProduct[]> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'getListProductsProvisionen': '',
            'sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return AdditionalServicesProduct.createListFromResponse(response.data)
    },

    async [actionTypes.FETCH_ADDITIONAL_SERVICES_DISCOUNT_LIST] (): Promise<AdditionalServicesProduct[]> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'getListProductsRabatte': '',
            'sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return AdditionalServicesProduct.createListFromResponse(response.data)
    },

    async [actionTypes.FETCH_ADDITIONAL_SERVICES] ({ commit, state }, payload: AdditionalServicesPayload): Promise<AdditionalServices[]> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'year': payload.year,
            'secondYear': payload.secondYear,
            'month': payload.month,
            'secondMonth': payload.secondMonth,
            'type': payload.type,
            'sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return AdditionalServices.createListFromResponse(response.data)
    },

    async [actionTypes.FETCH_ADDITIONAL_SERVICES_EXPENSES] ({ commit, state }, payload: AdditionalServicesPayload): Promise<AdditionalServices[]> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'SpesenList': '',
            'year': payload.year,
            'secondYear': payload.secondYear,
            'month': payload.month,
            'secondMonth': payload.secondMonth,
            'sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return AdditionalServices.createListFromResponse(response.data)
    },

    async [actionTypes.FETCH_ADDITIONAL_SERVICES_PROVISION] ({ commit, state }, payload: AdditionalServicesPayload): Promise<AdditionalServices[]> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'ProvisionenList': '',
            'year': payload.year,
            'secondYear': payload.secondYear,
            'month': payload.month,
            'secondMonth': payload.secondMonth,
            'sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return AdditionalServices.createListFromResponse(response.data)
    },

    async [actionTypes.FETCH_ADDITIONAL_SERVICES_DISCOUNT] ({ commit, state }, payload: AdditionalServicesPayload): Promise<AdditionalServices[]> {
      const response = await axios.get('/api/Adressen',
        {
          params: {
            'RabatteList': '',
            'year': payload.year,
            'secondYear': payload.secondYear,
            'month': payload.month,
            'secondMonth': payload.secondMonth,
            'sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return AdditionalServices.createListFromResponse(response.data)
    },

    async [actionTypes.INSERT_ADDITIONAL_SERVICE] ({ commit, state }, payload: AdditionalServicePayload ): Promise<boolean> {
      const response = await axios.post('/api/Adressen',
        {
          LGID: payload.LGID,
          Sprache: state.currentUser!.uiLanguage.syzId,
          Adresse: payload.addressId,
          Jahr: payload.year,
          Monat: payload.month,
          Mitarbeiter: payload.employeeId,
          ProduktID: payload.productId,
          Menge: payload.amount,
          Betrag: payload.price,
          Beschreibung: payload.description,
          Waehrung: payload.currency
        },
        {
          params: {
            'action': 'Insert',
            'type': payload.type,
          }
        })

      return response.data
    },

    async [actionTypes.EDIT_ADDITIONAL_SERVICE] ({ commit, state }, payload: AdditionalServicePayload ): Promise<boolean> {
      const response = await axios.post('/api/Adressen',
        {
          ID: payload.id,
          LGID: payload.LGID,
          Sprache: state.currentUser!.uiLanguage.syzId,
          Adresse: payload.addressId,
          Jahr: payload.year,
          Monat: payload.month,
          Mitarbeiter: payload.employeeId,
          ProduktID: payload.productId,
          Menge: payload.amount,
          Betrag: payload.price,
          Beschreibung: payload.description,
          Waehrung: payload.currency
        },
        {
          params: {
            'UpdateLeistungen': ''
          }
        })

      return response.data
    },

    async [actionTypes.DELETE_ADDITIONAL_SERVICE] ({ commit, state }, payload: AdditionalServicePayload ): Promise<boolean> {
      const response = await axios.post('/api/Adressen',
        {
          ID: payload.id,
          LGID: payload.LGID,
          Sprache: state.currentUser!.uiLanguage.syzId,
          Adresse: payload.addressId,
          Jahr: payload.year,
          Monat: payload.month,
          Mitarbeiter: payload.employeeId,
          ProduktID: payload.productId,
          Menge: payload.amount,
          Betrag: payload.price,
          Beschreibung: payload.description,
          Waehrung: payload.currency
        },
        {
          params: {
            'DeleteLeistungen': ''
          }
        })

      return response.data
    },

    async [actionTypes.INSERT_ADDITIONAL_SERVICE_EXPENSES] ({ commit, state }, payload: AdditionalServicePayload ): Promise<boolean> {

      let customParams: any
      if(payload.type === '1') {
        customParams = { 'ProductSpesenMitInsert': '' }
      } else if (payload.type === '2') {
        customParams = { 'ProductSpesenKunInsert': '' }
      }

      const response = await axios.post('/api/Adressen',
        {
          LGID: payload.LGID,
          Sprache: state.currentUser!.uiLanguage.syzId,
          Adresse: payload.addressId,
          Jahr: payload.year,
          Monat: payload.month,
          Mitarbeiter: payload.employeeId,
          ProduktID: payload.productId,
          Menge: payload.amount,
          Betrag: payload.price,
          Beschreibung: payload.description,
          Waehrung: payload.currency
        },
        {
          params: {
            ...customParams
          }
        })

      return response.data
    },

    async [actionTypes.EDIT_ADDITIONAL_SERVICE_EXPENSES] ({ commit, state }, payload: AdditionalServicePayload ): Promise<boolean> {

      let customParams: any
      if(payload.type === '1') {
        customParams = { 'UpdateSpesenMit': '' }
      } else if (payload.type === '2') {
        customParams = { 'UpdateSpesenKun': '' }
      }

      const response = await axios.post('/api/Adressen',
        {
          ID: payload.id,
          LGID: payload.LGID,
          Sprache: state.currentUser!.uiLanguage.syzId,
          Adresse: payload.addressId,
          Jahr: payload.year,
          Monat: payload.month,
          Mitarbeiter: payload.employeeId,
          ProduktID: payload.productId,
          Menge: payload.amount,
          Betrag: payload.price,
          Beschreibung: payload.description,
          Waehrung: payload.currency
        },
        {
          params: {
            ...customParams
          }
        })

      return response.data
    },

    async [actionTypes.DELETE_ADDITIONAL_SERVICE_EXPENSES] ({ commit, state }, payload: AdditionalServicePayload ): Promise<boolean> {
      const response = await axios.post('/api/Adressen',
        {
          ID: payload.id,
          LGID: payload.LGID,
          Sprache: state.currentUser!.uiLanguage.syzId,
          Adresse: payload.addressId,
          Jahr: payload.year,
          Monat: payload.month,
          Mitarbeiter: payload.employeeId,
          ProduktID: payload.productId,
          Menge: payload.amount,
          Betrag: payload.price,
          Beschreibung: payload.description,
          Waehrung: payload.currency
        },
        {
          params: {
            'DeleteSpesen': ''
          }
        })

      return response.data
    },

    async [actionTypes.COMPLETE_SHIFT_LIST] ({ commit, state }, payload: Array<number>): Promise<ResponseBase> {
      const response = await axios.post('/api/Planung',
        payload,
        {
          params: {
            'abgeschlossen': 1
          }
        })
      return response.data
    },

    async [actionTypes.ACTIVATE_SHIFT_LIST] ({ commit, state }, payload: Array<number>): Promise<boolean> {
      const response = await axios.post('/api/Planung',
        payload,
        {
          params: {
            'aktiv': 1
          }
        })
      return response.data
    },

    async [actionTypes.DEACTIVATED_SHIFT_LIST] ({ commit, state }, payload: Array<number>): Promise<boolean> {
      const response = await axios.post('/api/Planung',
        payload,
        {
          params: {
            'inaktiv': 1
          }
        })
      return response.data
    },

    async [actionTypes.FETCH_INVOICING_DATA] ({ commit, state }, payload: InvoicePayload): Promise<InvoiceResponse> {
      const response = await axios.get('/api/PersonalDispo/GetInvoicingLists',
        {
          params: {
            'year': payload.year,
            'month': payload.month,
            'departmentId': payload.department
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_INVOICING_STATUS] ({ commit, state }, payload: InvoicePayload): Promise<InvoiceStatusResponse> {
      const response = await axios.get('api/Automatic/GetOne',
        {
          params: {
            'sp': 'ShowBillingStatus',
            'i_Year': payload.year,
            'i_Month': payload.month
          }
        })

      return response.data
    },

    async [actionTypes.CREATE_INVOICES] ({ commit, state }, payload: CreateInvoicesPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/PersonalDispo/CreateInvoice', payload)
      return response.data
    },

    async [actionTypes.FETCH_EMPLOYEE_ADDITIONAL] ({ commit, state }, payload: number): Promise<any> {
      const response = await axios.get('/api/Zusatzfelder',
        {
          params: {
            'Sprache': state.currentUser!.uiLanguage.syzId,
            'Mitarbeiter': payload
          }
        })

      return AdditionalGroup.createFromResponse(response.data)
    },

    async [actionTypes.SAVE_EMPLOYEE_ADDITIONAL] ({ commit, state }, payload: EmployeeAdditionalFieldsPayload, ): Promise<boolean> {
      const response = await axios.post('/api/Zusatzfelder', payload.fields,
        {
          params: {
            'Mitarbeiter': payload.employeeId
          }
        })
      return response.data
    },

    async [actionTypes.FETCH_EMPLOYEE_PLAN_DETAIL] ({ commit, state }, payload: EmployeePlanDetailPayload): Promise<GetEmployeePlanDetailResponse> {
      const response = await axios.get('/api/Planung/GetEmployeePlanDetail',
        {
          params: {
            'employeeId': payload.employeeId,
            'date': payload.date
          }
        })
      return response.data
    },

    async [actionTypes.FETCH_PROJECT_ADDITIONAL] ({ commit, state }, payload: number | null): Promise<any> {
      const response = await axios.get('/api/Zusatzfelder/GetProjectAdditionalItemsMetadata',
        {
          params: {
            'serie': payload,
            'Sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return AdditionalGroup.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_PRESELECTED_EMPLOYEE] ({ commit, state }, payload: number): Promise<AutomaticOneResponse> {
      const response = await axios.get('/api/Automatic/GetOne',
        {
          params: {
            'sp': 'Planning_PreSelectedEmployee',
            'i_AdressID': payload
          }
        })

      return response.data
    },

    async [actionTypes.PLANNING_CHECK_SERIES] ({ commit, state }, payload: number): Promise<AutomaticOneResponse> {
      const response = await axios.get('/api/Automatic/GetOne',
        {
          params: {
            'sp': 'Planung_CheckSeriesHasDauerISTset',
            'i_ProjektSerien': payload
          }
        })

      return response.data
    },

    async [actionTypes.PLANNING_UPDATE_PROJECT_SERIES_LENGTH] ({ commit, state }, payload: PlanningAssistantPeriodicityPayload): Promise<any> {
      const response = await axios.post('/api/Planung/UpdateProjectSeriesLength', payload)

      return response.data
    },

    async [actionTypes.PLANNING_SEARCH_PROJECT_LIST] ({ commit, state }, payload: number): Promise<PlanungLookupProjekteResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            sp: 'Planung_LookupProjekte',
            i_AdressID: payload
          }
        })

      return response.data
    },

    async [actionTypes.PLANNING_SEARCH_ABO_LIST] ({ commit, state }, payload: number): Promise<PlanungLookupProjekteResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            sp: 'Planung_LookupAbonnemente',
            i_AdressID: payload
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_PROJECT_GROUP] (): Promise<Array<ProjectGroup>> {
      const response = await axios.get('/api/Project/GetProjectSteps',
        {
          params: {
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return ProjectGroup.createFromResponse(response.data)
    },

    async [actionTypes.FETCH_PROJECT_DATE] (): Promise<AutomaticOneResponse> {
      const response = await axios.get('/api/Automatic/GetOne?sp=GetFromToDatesSearch')
      return response.data
    },

    async [actionTypes.FETCH_SEARCH_PROJECT_LIST] ({ commit, state }, payload: ProjectSearchRequest): Promise<ProjectSearch[]> {
      const response = await axios.post('/api/Project/SearchProject', payload)
      return ProjectSearch.createFromResponse(response.data.Results)
    },

    async [actionTypes.GET_PROJECT_DETAIL] ({ commit, state }, payload: number): Promise<ProjectDetail[]> {
      const response = await axios.get('/api/Project/GetProjectDetails',
        {
          params: {
            'projectId': payload,
            'languageid': state.currentUser!.uiLanguage.syzId
          }
        })

      return ProjectDetail.createFromListResponse(response.data.Project)
    },

    async [actionTypes.GET_PROJECT_DETAIL_FOOTER] ({ commit, state }, payload: number): Promise<ProjectDetailFooter> {
      const response = await axios.get('/api/Project/GetProjectFooter',
        {
          params: {
            'projectId': payload
          }
        })

      return ProjectDetailFooter.createFromResponse(response.data)
    },

    async [actionTypes.GET_PROJECT_DETAIL_HEADER] ({ commit, state }, payload: number): Promise<ProjectDetailHeader> {
      const response = await axios.get('/api/Project/GetProjectHeader',
        {
          params: {
            'projectId': payload,
            'languageid': state.currentUser!.uiLanguage.syzId
          }
        })

      return ProjectDetailHeader.createFromResponse(response.data.Header)
    },

    async [actionTypes.EDIT_PROJECT] ({ commit, state }, payload: UpdateProjectPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Project/UpdateProject', payload)

      return response.data
    },

    async [actionTypes.DELETE_PROJECT] ({ commit, state }, payload: DeleteProjectPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Project/DeleteProject', payload)
      return response.data
    },

    async [actionTypes.GET_PROJECT_DETAIL_LOOKUPS] ({ commit, state }, payload: number): Promise<GetProjectDetailLookupsResponse> {
      const response = await axios.get('api/Project/GetProjectDetailLookups',
        {
          params: {
            'projectDetailId': payload,
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.EDIT_PROJECT_DETAIL] ({ commit, state }, payload: EditProjectDetailPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Project/UpdateProjectDetail', payload)
      return response.data
    },

    async [actionTypes.DELETE_PROJECT_DETAIL] ({ commit, state }, payload: DeleteProjectDetailPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Project/DeleteProjectDetail', payload)
      return response.data
    },

    async [actionTypes.PROJECT_ASSISTANT_FETCH_START] ({ commit, state }): Promise<StartAssistantResponse> {
      const response = await axios.get('/api/NewProjectAssistant/StartAssistant',
        {
          params: {
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.PROJECT_ASSISTANT_FETCH_DEFAULT_VALUES] ({ commit, state }, payload: ProjectAssistantDefaultsPayload): Promise<ProjectAssistantDefaultsResponse> {
      const response = await axios.get('/api/NewProjectAssistant/StartAssistantGetDefaults',
        {
          params: {
            'addressId': payload.addressId,
            'prozessartId': payload.prozessartId,
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.PROJECT_ASSISTANT_CREATE_PROJECT] ({ commit, state }, payload: CreateProjectPayload): Promise<CreateProjectResponse> {
      const response = await axios.post('/api/NewProjectAssistant/CreateProject', payload)

      return response.data
    },

    async [actionTypes.PROJECT_ASSISTANT_FETCH_DETAIL_START] ({ commit, state }, payload: number): Promise<StartDetailAssistantResponse> {
      const response = await axios.get('/api/NewProjectAssistant/StartDetailAssistant',
        {
          params: {
            'projectId': payload,
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.PROJECT_ASSISTANT_FETCH_PRICING] ({ commit, state }, payload: GetPricingRequestPayload): Promise<GetPricingResponse> {
      const response = await axios.post('/api/Pricing/GetPricing', payload)

      return response.data
    },

    async [actionTypes.PROJECT_ASSISTANT_FETCH_UNIT_LIST] ({ commit, state }, payload: any): Promise<GetUnitCodeListResponse> {
      const response = await axios.get('/api/NewProjectAssistant/GetUnitCodeList',
        {
          params: {
            'productId': payload.productId,
            'projectId': payload.projectId,
            'lagerung': payload.lagerung,
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.PROJECT_ASSISTANT_CREATE_PROJECT_DETAIL] ({ commit, state }, payload: CreateProjectDetailPayload): Promise<CreateProjectDetailResponse> {
      const response = await axios.post('/api/NewProjectAssistant/CreateProjectDetail', payload)

      return response.data
    },

    async [actionTypes.QUICK_INSERT_PROJECT_DETAILS] ({ commit, state }, payload: any): Promise<QuickInsertResponse> {
      const response = await axios.post('/api/Project/QuickInsertProjectDetails', payload)

      return response.data
    },

    async [actionTypes.SET_PROJECT_LOCK_STATUS] ({ commit, state }, payload: any): Promise<ResponseBase> {
      const response = await axios.get('/api/Automatic/Do',
        {
          params: {
            'sp': 'Project_SetProjectLockStatus',
            'sl': 1,
            'o': 'Projekte',
            'i_Projekte': payload.projectId,
            'i_Locked': payload.value
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_SEARCH_PRODUCT_LIST] ({ commit, state }, payload: ProductSearchRequest): Promise<ProductSearchResponse> {
      const response = await axios.post('/api/NewProjectAssistant/ProductSearch', payload)

      return response.data
    },

    async [actionTypes.FETCH_PROJECT_ADDITIONAL_FIELDS] ({ commit, state }, payload: number): Promise<AdditionalGroup[]> {
      const response = await axios.get('/api/Project/GetProjectAdditionalFields',
        {
          params: {
            'projectId': payload,
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return AdditionalGroup.createFromResponse(response.data.AdditionalFields)
    },

    async [actionTypes.SAVE_PROJECT_ADDITIONAL] ({ commit, state }, payload: AdditionalFieldsProjectPayload, ): Promise<boolean> {
      const response = await axios.post('/api/Project/UpdateProjectAdditionalFields', payload)

      return !response.data.IsError
    },

    async [actionTypes.SELECT_UI_LANGUAGE] ({ commit, state }, payload: UiLanguageItem): Promise<void> {
      commit(mutationTypes.SET_UI_LANGUAGE, payload)

      localStorage.setItem('uiLanguageCode', payload.code)
      i18n.locale = payload.code

      /*await axios.get('/api/User/ChangeUiLanguage',
        {
          params: {
            'newLanguageId': payload.syzId,
          }
        })*/
    },

    async [actionTypes.FETCH_ADDRESSES_PROJECT_ADDRESS] ({ commit, state }, payload: number): Promise<AddressProjectAddressResponse> {
      const response = await axios.get('/api/Project/GetProjectAddresses',
        {
          params: {
            'addressId': payload,
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_COUNTRIES_LIST] (): Promise<GetCountriesResponse> {
      const response = await axios.get('/api/Project/GetCountries',
        {
          params: {
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.SAVE_ADDRESSES_PROJECT_ADDRESS] ({ commit, state }, payload: InsertProjectAddressRequestPayload): Promise<SaveUpdateDeleteProjectAddressResponse> {
      const response = await axios.post('/api/Project/InsertProjectAddress', payload)
      return response.data
    },

    async [actionTypes.UPDATE_ADDRESSES_PROJECT_ADDRESS] ({ commit, state }, payload: UpdateProjectAddressRequestPayload): Promise<SaveUpdateDeleteProjectAddressResponse> {
      const response = await axios.post('/api/Project/UpdateProjectAddress', payload)
      return response.data
    },

    async [actionTypes.DELETE_ADDRESSES_PROJECT_ADDRESS] ({ commit, state }, payload: DeleteProjectAddressRequestPayload): Promise<SaveUpdateDeleteProjectAddressResponse> {
      const response = await axios.post('/api/Project/DeleteProjectAddress', payload)
      return response.data
    },

    async [actionTypes.FETCH_SEARCH_ADDRESS_LIST] ({ commit, state }, payload: ProjectAddressSearchRequestPayload): Promise<ProjectAddressSearchResponse> {
      const response = await axios.post('/api/Project/SearchProjectAddresses', payload)
      return response.data
    },

    async [actionTypes.FETCH_GENERAL_SEARCH_ADDRESS_LIST] ({ commit, state }, payload: ProjectGeneralAddressSearchRequestPayload): Promise<ProjectAddressSearchResponse> {
      const response = await axios.post('/api/Project/GeneralSearch', payload)
      return response.data
    },

    async [actionTypes.FETCH_ADDRESS_EMPLOYEE_LIST] ({ commit, state }, payload: number): Promise<GetSachbearbeiterResponse> {
      const response = await axios.get('/api/Adressen/GetSachbearbeiter', {
        params: {
          'adressID': payload
        }
      })
      return response.data
    },

    async [actionTypes.FETCH_ADDRESS_WEB_REPORT] ({ commit, state }, payload: number): Promise<any> {
      const response = await axios.get('/api/PdfForms/GetPdfFormByAddress', {
        params: {
          'AddressId': payload,
          'formName': 'Pflichtenheft'
        }
      })
      return response.data
    },

    async [actionTypes.SAVE_ADDRESS_WEB_REPORT] ({ commit, state }, payload: any): Promise<any> {
      const response = await axios.post('/api/PdfForms/InsertPdfForm', payload)
      return response.data
    },

    async [actionTypes.TRANSFER_ADDRESS_WEB_REPORT] ({ commit, state }, payload: number): Promise<any> {
      const response = await axios.get('/api/PdfForms/StorePdfFormToAddressZF', {
        params: {
          'addressId': payload
        }
      })
      return response.data
    },

    async [actionTypes.FETCH_PROJECT_SPECIFICATIONS] ({ commit, state }, payload: number): Promise<AddressProjectSpecificationsResponse> {
      const response = await axios.get('/api/AdressVorgaben/Get', {
        params: {
          'addressId': payload,
          'languageId': state.currentUser!.uiLanguage.syzId
        }
      })
      return response.data
    },

    async [actionTypes.CREATE_PROJECT_SPECIFICATIONS] ({ commit, state }, payload: InsertAdressVorgabenPayload): Promise<InsertAdressVorgabenResponse> {
      const response = await axios.post('/api/AdressVorgaben/Insert', payload)
      return response.data
    },

    async [actionTypes.UPDATE_PROJECT_SPECIFICATIONS] ({ commit, state }, payload: UpdateAdressVorgabenPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/AdressVorgaben/Update', payload)
      return response.data
    },

    async [actionTypes.DELETE_PROJECT_SPECIFICATIONS] ({ commit, state }, payload: DeleteAdressVorgabenpayload): Promise<ResponseBase> {
      const response = await axios.post('/api/AdressVorgaben/Delete', payload)
      return response.data
    },

    async [actionTypes.GET_PROJECT_RECEIPT_LIST] ({ commit, state }, payload: number): Promise<GetProjectReceiptsResponse> {
      const response = await axios.get('/api/ReprintAndCancel/GetProjectReceipts',
        {
          params: {
            'projectId': payload,
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

        return response.data
    },

    async [actionTypes.GET_PROJECT_REPRINT_LIST] ({ commit, state }, payload: number): Promise<ReprintListResponse> {
      const response = await axios.get('/api/ReprintAndCancel/GetReprintList',
        {
          params: {
            'belegId': payload,
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.PROJECT_REPRINT] ({ commit, state }, payload: ProjectReprintPayload): Promise<ProjectReprintResponse> {
      const response = await axios.post('/api/ReprintAndCancel/Reprint', null, {
        params: {
          'belegId': payload.belegId,
          'printStep': payload.printStep,
          'formular': payload.formular,
          'languageId': state.currentUser!.uiLanguage.syzId
        }
      })

      return response.data
    },

    async [actionTypes.PROJECT_PREVIEW] ({ commit, state }, payload: ProjectReprintPayload): Promise<any> {
      const response = await axios.get('/api/ReprintAndCancel/Preview',
        {
          responseType: 'arraybuffer',
          params: {
            'belegId': payload.belegId,
            'printStep': payload.printStep,
            'formular': payload.formular,
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return response
    },

    async [actionTypes.PROJECT_REPRINT_CANCEL] ({ commit, state }, payload: number): Promise<ProjectReprintCancelResponse> {
      const response = await axios.post('/api/ReprintAndCancel/Cancel', null, {
        params: {
          'belegId': payload
        }
      })

      return response.data
    },

    async [actionTypes.GET_PROJECT_ARCHIVE_LIST] ({ commit, state }, payload: number): Promise<GetArchiveResponse> {
      const response = await axios.get('/api/ReprintAndCancel/GetArchive',
        {
          params: {
            'belegId': payload
          }
        })

      return response.data
    },

    async [actionTypes.GET_PROJECT_PDF_NAME] ({ commit, state }, payload: number): Promise<GetPdfUrlResponse> {
      const response = await axios.get('/api/ReprintAndCancel/GetPdfName',
        {
          params: {
            'archiveId': payload
          }
        })

      return response.data
    },

    async [actionTypes.GET_PROJECT_PDF] ({ commit, state }, payload: number): Promise<any> {
      const response = await axios.get('/api/Archive/GetPdfById',
        {
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/pdf',
            'Accept': 'application/pdf'
          },
          params: {
            'archiveId': payload
          }
        })

      return response.data
    },

    async [actionTypes.GET_PROJECT_BELEG_DATA] ({ commit, state }, payload: number): Promise<GetBelegDataResponse> {
      const response = await axios.get('/api/ReprintAndCancel/GetBelegData',
        {
          params: {
            'belegId': payload
          }
        })

      return response.data
    },

    async [actionTypes.UPDATE_PROJECT_BELEG_DATA] ({ commit, state }, payload: BelegDatenPayload): Promise<UpdateBelegDataResponse> {
      const response = await axios.post('/api/ReprintAndCancel/UpdateBelegData', payload)

      return response.data
    },

    async [actionTypes.GET_PROJECT_LOOK_UPS] ({ commit, state }): Promise<GetLookupsResponse> {
      const response = await axios.get('/api/ReprintAndCancel/GetLookups',
        {
          params: {
            'languageid': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.GET_PROJECT_HEADER_FOOTER_TEXT] ({ commit, state }, payload: number): Promise<GetArchiveResponse> {
      const response = await axios.get('/api/ReprintAndCancel/GetKopfFussData',
        {
          params: {
            'belegId': payload
          }
        })

      return response.data
    },

    async [actionTypes.UPDATE_PROJECT_HEADER_FOOTER_TEXT] ({ commit, state }, payload: KopfFussDataPayload): Promise<UpdateKopfFussResponse> {
      const response = await axios.post('/api/ReprintAndCancel/UpdateKopfFussData', payload)

      return response.data
    },

    async [actionTypes.GET_PROJECT_REPRINT_ACCOUNTING_RECORDS] ({ commit, state }, payload: number): Promise<GetFinancialActivityResponse> {
      const response = await axios.get('/api/ReprintAndCancel/GetFinancialActivity',
        {
          params: {
            'belegId': payload
          }
        })

      return response.data
    },

    async [actionTypes.GET_PROJECT_REPRINT_PAYMENT_INFORMATION] ({ commit, state }, payload: number): Promise<GetPaymentInformationResponse> {
      const response = await axios.get('/api/ReprintAndCancel/GetPaymentInformation',
        {
          params: {
            'belegId': payload,
            'sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.BOOKING_ASSISTANT_FETCH_START_BOOKING_DATA] ({ commit, state }, payload: StartBookingPayload): Promise<StartBookingResponse> {
      const response = await axios.post('/api/Booking/StartBooking', payload)

      return response.data
    },

    async [actionTypes.BOOKING_ASSISTANT_GO_TO_POSITIONEN_STEP] ({ commit, state }, payload: PositionenBookingPayload): Promise<PositionenBookingResponse> {
      const response = await axios.post('/api/Booking/GotoPositionenStep', payload)

      return response.data
    },

    async [actionTypes.BOOKING_ASSISTANT_GO_TO_MENGEN_STEP] ({ commit, state }, payload: MengenBookingPayload): Promise<MengenBookingResponse> {
      const response = await axios.post('/api/Booking/GotoMengenStep', payload)

      return response.data
    },

    async [actionTypes.BOOKING_ASSISTANT_SAVE_MENGEN_STEP] ({ commit, state }, payload: SaveMengenStepPayload): Promise<SaveMengenStepResponse> {
      const response = await axios.post('/api/Booking/SaveMengenStep', payload)

      return response.data
    },

    async [actionTypes.BOOKING_ASSISTANT_GO_TO_BELEG_STEP] ({ commit, state }, payload: BelegBookingPayload): Promise<BelegBookingResponse> {
      const response = await axios.post('/api/Booking/GotoBelegStep', payload)

      return response.data
    },

    async [actionTypes.BOOKING_ASSISTANT_SAVE_BELEG_STEP] ({ commit, state }, payload: SaveBelegStepPayload): Promise<SaveBelegStepResponse> {
      const response = await axios.post('/api/Booking/SaveBelegStep', payload)

      return response.data
    },

    async [actionTypes.BOOKING_ASSISTANT_HAS_FIBU_STEP] ({ commit, state }, payload: HasFibuBookingPayload): Promise<HasFibuBookingResponse> {
      const response = await axios.post('/api/Booking/HasFibuStep', payload)

      return response.data
    },

    async [actionTypes.BOOKING_ASSISTANT_GO_TO_FIBU_STEP] ({ commit, state }, payload: FibuBookingPayload): Promise<FibuBookingResponse> {
      const response = await axios.post('/api/Booking/GotoFibuStep', payload)

      return response.data
    },

    async [actionTypes.BOOKING_ASSISTANT_SAVE_FIBU_STEP] ({ commit, state }, payload: SaveFibuStepPayload): Promise<SaveFibuStepResponse> {
      const response = await axios.post('/api/Booking/SaveFibuStep', payload)

      return response.data
    },

    async [actionTypes.BOOKING_ASSISTANT_GO_TO_PAPIERI_STEP] ({ commit, state }, payload: PapieriBookingPayload): Promise<PapieriBookingResponse> {
      const response = await axios.post('/api/Booking/GotoPapieriStep', payload)

      return response.data
    },

    async [actionTypes.BOOKING_ASSISTANT_FINISH_BOOKING] ({ commit, state }, payload: FinishBookingPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Booking/FinishBooking', payload)

      return response.data
    },

    async [actionTypes.BOOKING_ASSISTANT_CANCEL_BOOKING] ({ commit, state }, payload: CancelBookingPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Booking/CancelBooking', payload)

      return response.data
    },

    async [actionTypes.FETCH_TOOLS] ({ commit, state }): Promise<GetToolsResponse> {
      const response = await axios.get('/api/Tools/Get',
        {
          params: {
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_TOOLS_METADATA] ({ commit, state }): Promise<any> {
      const response = await axios.get('/api/Automatic/GetMultipleWithMetadata',
        {
          params:{
            sp: 'FIBUUebergabe_GetLists',
            i_Sprache: state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_FIBU_TOOLS] ({ commit, state }, payload: any): Promise<any> {
      const response = await axios.get('/api/FIBUUebergabe/ShowFIBUBelege',
        {
          params: payload
        })

      return response.data
    },

    async [actionTypes.TOOLS_ACTION] ({ commit, state }, payload: ToolsActionPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/FIBUUebergabe/CreateFIBUAction', {
        Action: payload.action,
        FIBUBeleg: payload.fibuBeleg,
        Sprache: state.currentUser!.uiLanguage.syzId
      })

      return response.data
    },

    async [actionTypes.RUN_TOOLS] ({ commit, state }, payload: string): Promise<RunToolResponse> {
      const response = await axios.get('/api/Tools/Run',
        {
          params: {
            'code': payload
          }
        })

      return response.data
    },

    async [actionTypes.GET_LOGGED_IN_USERS] ({ commit, state }): Promise<LoggedInUsersResponse> {
      const response = await axios.get('/api/UserInformation/GetLoggedInUsers')
      return response.data
    },

    async [actionTypes.LOG_USER_OUT_BY_TOKEN] ({ commit, state }, payload: LogUserOutByTokenPayload): Promise<boolean> {
      const response = await axios.get('/api/UserInformation/LogoutByToken',
        {
          params:{
            userId: payload.userId,
            token: payload.token
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_EMPLOYEE_LEVEL] ({ commit, state }): Promise<GetEmployeeLevelResponse> {
      const response = await axios.get('/api/Licensing/GetEmployeeLevel',
        {
          params:{
            languageId: state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.UPDATE_EMPLOYEE_LEVEL] ({ commit, state }, payload: UpdateProfitCenterAndDepartmentPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Security/UpdateProfitCenterAndDepartmentAndSecurityRolle', payload)

      return response.data
    },

    async [actionTypes.GET_EMPLOYEE_SECURITY] ({ commit, state }): Promise<EmployeeSecurityRoleResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params:{
            sp: 'Security_GetMitarbeiterSecurityRollen',
            i_Sprache: state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_REQUIREMENTS_EMPLOYEE_AND_SECURITY] ({ commit, state }): Promise<EmployeeAndSecurityResponse> {
      const response = await axios.get('/api/Automatic/GetMultiple',
        {
          params:{
            sp: 'Vorgaben_MitarbeiterAndSecRollen',
            i_Sprache: state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_EMPLOYEE_REQUIREMENTS] ({ commit, state }, payload: number): Promise<EmployeeRequirementsResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params:{
            sp: 'Vorgaben_GetMitarbeiterVorgaben',
            i_Mitarbeiter: payload,
            i_Sprache: state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_SECURITY_REQUIREMENTS] ({ commit, state }, payload: number): Promise<EmployeeRequirementsResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params:{
            sp: 'Vorgaben_GetSecurityRolleVorgaben',
            i_SecurityRolle: payload,
            i_Sprache: state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_REQUIREMENTS_METADATA] ({ commit, state }): Promise<EmployeeRequirementsValuesResponse> {
      const response = await axios.get('/api/Automatic/GetMultipleWithMetadata',
        {
          params:{
            sp: 'Vorgaben_GetAllValues',
            i_Sprache: state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.SAVE_EMPLOYEE_REQUIREMENTS] ({ commit, state }, payload: SaveEmployeeRequirementsPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Automatic/PostOne', {Data: payload},
        {
          params: {
            sp: 'Vorgaben_UpsertMitarbeiterDefault',
            sl: 1,
            o: 'Vorgaben'
          }
        })

      return response.data
    },

    async [actionTypes.DELETE_EMPLOYEE_REQUIREMENTS] ({ commit, state }, payload: DeleteEmployeeRequirementsPayload): Promise<ResponseBase> {
      const response = await axios.get('/api/Automatic/Do',
        {
          params:{
            sp: 'Vorgaben_DeleteMitarbeiterDefault',
            sl:1,
            o: 'Vorgaben',
            i_Mitarbeiter: payload.i_Mitarbeiter,
            i_VorgabenName: payload.i_VorgabenName
          }
        })

      return response.data
    },

    async [actionTypes.SAVE_SECURITY_ROLE_REQUIREMENTS] ({ commit, state }, payload: SaveSecurityRequirementsPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Automatic/PostOne', {Data: payload},
        {
          params: {
            sp: 'Vorgaben_UpsertSecurityRolleDefault',
            sl: 1,
            o: 'Vorgaben'
          }
        })

      return response.data
    },

    async [actionTypes.DELETE_SECURITY_ROLE_REQUIREMENTS] ({ commit, state }, payload: DeleteSecurityRequirementsPayload): Promise<ResponseBase> {
      const response = await axios.get('/api/Automatic/Do',
        {
          params:{
            sp: 'Vorgaben_DeleteSecurityRolleDefault',
            sl:1,
            o: 'Vorgaben',
            i_SecurityRolle: payload.i_SecurityRolle,
            i_VorgabenName: payload.i_VorgabenName
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_GROUP] (): Promise<ProductGroupResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            sp: 'Produkte_GetProduktGruppen',
            sl: 1,
            i_Sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_FELD_LIST] (): Promise<ProductZusatzfelderTypesResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            sp: 'Produkte_GetZusatzFelderList',
            sl: 1,
            i_Sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.SEARCH_PRODUCT_LIST] ({ commit, state }, payload: ProductSearchPayload): Promise<ProductSearchResponse> {
      const response = await axios.post('/api/Product/Search', payload)

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_TEXT_ART_LIST] (): Promise<ProductTextArtResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            sp: 'Produkte_GetTextArten',
            i_Sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_DESCRIPTION_TEXTS] ({ commit, state }, payload: number): Promise<GetProductDescriptionResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            sp: 'Produkte_GetProdukteBezeichnungen',
            i_Produkt: payload
          }
        })

      return response.data
    },

    async [actionTypes.UPDATE_PRODUCT_DESCRIPTION_TEXTS] ({ commit, state }, payload: UpsertProdukteBezeichnungenPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Product/UpsertProdukteBezeichnungen', payload)

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_TEXTS] ({ commit, state }, payload: GetProductTextsPayload): Promise<GetProductTextsResponse> {
      const response = await axios.get('/api/Product/GetProductTexts',
        {
          params: {
            product: payload.productId,
            art: payload.artId
          }
        })

      return response.data
    },

    async [actionTypes.UPDATE_PRODUCT_TEXTS] ({ commit, state }, payload: UpsertProdukteTextePayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Product/UpsertProdukteTexte', payload)

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_NOTICES] ({ commit, state }, payload: number): Promise<GetProductNoticesResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            sp: 'Produkte_GetProdukteBemerkungen',
            i_Produkt: payload
          }
        })

      return response.data
    },

    async [actionTypes.UPDATE_PRODUCT_NOTICES] ({ commit, state }, payload: UpsertProdukteBemerkungenPayload): Promise<ResponseBase> {
      const response = await axios.post('/api/Product/UpsertProdukteBemerkungen', payload)

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_UNIT_LIST] (): Promise<ProductUnitResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            sp: 'Produkte_GetEinheiten',
            i_Sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_SUBSTITUTE] ({ commit, state }, id: number): Promise<ProductSubstituteResponse> {
      const response = await axios.get('/api/Automatic/GetOne',
        {
          params: {
            sp: 'Produkte_GetErsatz',
            sl: 1,
            i_Ersatz: id,
            i_Sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.CREATE_PRODUCT] ({ commit, state }, payload: CreateProductPayload): Promise<UpsertProductResponse> {
      const response = await axios.post('/api/Product/Add', payload)

      return response.data
    },

    async [actionTypes.UPDATE_PRODUCT] ({ commit, state }, payload: UpdateProductPayload): Promise<UpsertProductResponse> {
      const response = await axios.post('/api/Product/Update', payload)

      return response.data
    },

    async [actionTypes.DELETE_PRODUCT] ({ commit, state }, payload: number): Promise<ResponseBase> {
      const response = await axios.delete('/api/Product/Delete', {
        params: {
          productId: payload
        }
      })

      return response.data
    },

    async [actionTypes.COPY_PRODUCT] ({ commit, state }, id: number): Promise<any> {
      const response = await axios.get('/api/Product/Copy',
        {
          params: {
            productId: id,
            languageId: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_ADDITIONAL] ({ commit, state }, id: number): Promise<ProductAdditionalFieldsGetItemResponse> {
      const response = await axios.get('/api/Product/GetZusatzfelder',
        {
          params: {
            productId: id,
            languageId: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.SAVE_PRODUCT_ADDITIONAL] ({ commit, state }, payload: UpsertZusatzfelderRequest): Promise<ResponseBase> {
      const response = await axios.post('/api/Product/UpsertZusatzfelder', payload)

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_NOTES] ({ commit, state }, id: number): Promise<ProductNotesResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            sp: 'Produkte_GetNotizen',
            i_Produkt: id,
            i_Author: state.currentUser!.id
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_NOTES_METADATA] ({ commit, state }): Promise<ProductNotesMetaDataResponse> {
      const response = await axios.get('/api/Automatic/GetMultipleWithMetadata',
        {
          params: {
            sp: 'Produkte_GetNotizenLists',
            i_Sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.SAVE_PRODUCT_NOTE] ({ commit, state }, payload: UpsertProduktNotizenRequest): Promise<ProductNoteUpsertResponse> {
      const response = await axios.post('/api/Product/UpsertProduktNotizen', payload)

      return response.data
    },

    async [actionTypes.DELETE_PRODUCT_NOTE] ({ commit, state }, payload: number): Promise<ResponseBase> {
      const response = await axios.delete('/api/Product/DeleteProduktNotizen',
        {
          params: {
            noteId: payload
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_STORAGE_DATA] ({ commit, state }, payload: any): Promise<any> {
      const response = await axios.get('/api/Automatic/GetMultipleWithMetadata',
        {
          params: {
            sp: 'Produkte_GetLagerungen',
            i_Produkt: payload.produktId,
            i_Lagerung: payload.lagerungId,
            i_Sprache: state.selectedUiLanguage!.syzId,
            sl: 1
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_STORAGE_METADATA] ({ commit, state }, payload: number): Promise<any> {
      const response = await axios.get('/api/Automatic/GetMultipleWithMetadata',
        {
          params: {
            sp: 'Produkte_GetLagerungenLists',
            i_ProduktEinheit: payload,
            i_Sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.UPSERT_PRODUCT_STORAGE_DATA] ({ commit, state }, payload: any): Promise<any> {
      const response = await axios.post('/api/Product/UpsertLagerungen', payload)

      return response.data
    },

    async [actionTypes.DELETE_PRODUCT_STORAGE_DATA] ({ commit, state }, payload: DeleteProductStoragePayload): Promise<ResponseBase> {
      const response = await axios.delete('/api/Product/DeleteLagerungen',
        {
          params: {
            lagerungenId: payload.lagerungenId,
            productId: payload.produktId
          }
        })

      return response.data
    },

    async [actionTypes.UPSERT_PRODUCT_PRICE] ({ commit, state }, payload: UpsertProductPricePayload): Promise<any> {
      const response = await axios.post('/api/Automatic/PostOnes', payload, {
        params: {
          sp: 'Produkte_UpsertLagerungenPreise',
          sl: 1,
          o: 'Produkte'
        }
      })

      return response.data
    },

    async [actionTypes.DELETE_PRODUCT_PRICE] ({ commit, state }, payload: number): Promise<ResponseBase> {
      const response = await axios.get('/api/Automatic/Do',
        {
          params: {
            sp: 'Produkte_DeleteLagerungenPreise',
            i_ID: payload,
            sl: 1,
            o: 'Produkte'
          }
        })

      return response.data
    },






    async [actionTypes.FETCH_PRODUCT_CUSTOMERS_AND_SUPPLIERS_DATA] ({ commit, state }, payload: number): Promise<any> {
      const response = await axios.get('/api/Automatic/GetMultipleWithMetadata',
        {
          params: {
            sp: 'Produkte_GetProduktAdressen',
            i_Produkt: payload,
            i_Sprache: state.selectedUiLanguage!.syzId,
            sl: 1
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_CUSTOMERS_AND_SUPPLIERS_METADATA] ({ commit, state }): Promise<any> {
      const response = await axios.get('/api/Automatic/GetMultipleWithMetadata',
        {
          params: {
            sp: 'Produkte_GetProduktAdressenLists',
            i_Sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.UPSERT_PRODUCT_ADDRESS] ({ commit, state }, payload: any): Promise<any> {
      const response = await axios.post('/api/Automatic/PostOnes', payload,
        {
          params: {
            sp: 'Produkte_UpsertProduktAdresse',
            sl: 1,
            o: 'Produkte'
          }
        })

      return response.data
    },

    async [actionTypes.DELETE_PRODUCT_ADDRESS] ({ commit, state }, payload: number): Promise<any> {
      const response = await axios.get('/api/Automatic/Do',
        {
          params: {
            sp: 'Produkte_DeleteProduktAdressen',
            i_ID: payload,
            sl: 1,
            o: 'Produkte'
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_PRODUCT_ADDRESS_PRICE] ({ commit, state }, payload: number): Promise<any> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            sp: 'Produkte_GetProduktAdressenPreise',
            i_ProduktAdresse: payload,
            sl: 1
          }
        })

      return response.data
    },

    async [actionTypes.UPSERT_PRODUCT_ADDRESS_PRICE] ({ commit, state }, payload: UpsertProductAddressPricePayload): Promise<any> {
      const response = await axios.post('/api/Automatic/PostOnes', payload,
        {
          params: {
            sp: 'Produkte_UpsertProduktAdressenPreise',
            sl: 1,
            o: 'Produkte'
          }
        })

      return response.data
    },

    async [actionTypes.DELETE_PRODUCT_ADDRESS_PRICE] ({ commit, state }, payload: number): Promise<any> {
      const response = await axios.get('/api/Automatic/Do',
        {
          params: {
            sp: 'Produkte_DeleteProduktAdressenPreise',
            i_ID: payload,
            sl: 1,
            o: 'Produkte'
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_PLANING_FILTER] ({ commit, state }, payload: PlaningFilterPayload): Promise<GetPlaningFilterData> {
      const response = await axios.get('/api/Automatic/GetMultiple',
        {
          params:{
            sp: 'Planung_FilterCalendar',
            i_SearchString: payload.i_SearchString,
            i_Status: payload.i_Status,
            i_Abt: payload.i_Abt,
            i_FirstDate: payload.i_FirstDate,
            i_LastDate: payload.i_LastDate,
            i_Pfc: payload.i_Pfc,
            i_Sprache: state.currentUser!.uiLanguage.syzId
          }
        })
      return response.data
    },

    async [actionTypes.FETCH_PROFIT_CENTER_ADDITIONAL] ({ commit, state }, payload: number): Promise<ProfitCenterAdditionalFieldsGetItemResponse> {
      const response = await axios.get('/api/Zusatzfelder/GetProfitCenterAdditionalFields',
        {
          params:{
            profitCenter: payload,
            languageId: state.currentUser!.uiLanguage.syzId
          }
        })

      return response.data
    },

    async [actionTypes.SAVE_PROFIT_CENTER_ADDITIONAL] ({ commit, state }, payload: ProfitCenterAdditionalFieldsUpdatePayload ): Promise<ResponseBase> {
      const response = await axios.post('/api/Zusatzfelder/UpdateProfitCenterAdditionalFields', payload)
      return response.data
    },

    async [actionTypes.SAVE_PROFIT_CENTER_ADDITIONAL_MULTI_LANGUAGE] ({ commit, state }, payload: ProfitCenterAdditionalFieldsMultiLanguageUpdatePayload ): Promise<ResponseBase> {
      const response = await axios.post('/api/Zusatzfelder/UpdateProfitCenterZFB', payload)
      return response.data
    },

    async [actionTypes.FETCH_PRINTING_ACTIVITY_LIST] ({ commit, state }): Promise<PrintingActivityResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params:{
            sp: 'Printing_OverviewPrintingActivity',
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_RECRUITING_GROUP] (): Promise<Array<RecruitingGroup>> {
      /*const response = await axios.get('/api/RecruitingGroup',
        {
          params: {
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return RecruitingGroup.createFromResponse(response.data)*/
      return RecruitingGroup.createFromResponse([
        {
          ID: 1,
          Code: '1',
          Bezeichnung: 'RecruitingGroup1',
          children: [
            {id: 1, name: "Peter", vorname: "Hanes"},
            {id: 2, name: "Miroslav", vorname: "Strelec"},
            {id: 3, name: "Samuel", vorname: "Mikloš"},
            {id: 4, name: "Peter", vorname: "Aláč"},
            {id: 5, name: "Marek", vorname: "Trebuľa"}
          ]
        },
        {
          ID: 2,
          Code: '2',
          Bezeichnung: 'RecruitingGroup2',
          children: [
            {id: 11, name: "Peter", vorname: "Hanes"},
            {id: 22, name: "Miroslav", vorname: "Strelec"},
            {id: 33, name: "Samuel", vorname: "Mikloš"},
            {id: 44, name: "Peter", vorname: "Aláč"},
            {id: 55, name: "Marek", vorname: "Trebuľa"}
          ]
        },
        {
          ID: 3,
          Code: '3',
          Bezeichnung: 'RecruitingGroup3',
          children: [
            {id: 111, name: "Peter", vorname: "Hanes"},
            {id: 222, name: "Miroslav", vorname: "Strelec"},
            {id: 333, name: "Samuel", vorname: "Mikloš"},
            {id: 444, name: "Peter", vorname: "Aláč"},
            {id: 555, name: "Marek", vorname: "Trebuľa"}
          ]
        }
      ])
    },

    async [actionTypes.FETCH_RECRUITING_DATA] (): Promise<Array<any>> {
      /*const response = await axios.get('/api/RecruitingGroup',
        {
          params: {
            'languageId': state.currentUser!.uiLanguage.syzId
          }
        })

      return RecruitingGroup.createFromResponse(response.data)*/
      return [
        {id: 1, name: "Peter", vorname: "Hanes"},
        {id: 2, name: "Miroslav", vorname: "Strelec"},
        {id: 3, name: "Samuel", vorname: "Mikloš"},
        {id: 4, name: "Peter", vorname: "Aláč"},
        {id: 5, name: "Marek", vorname: "Trebuľa"}
      ]
    },

    async [actionTypes.FETCH_COMMISSION_GROUP] (): Promise<CommissionGroup[]> {
      const response = await axios.get('/api/Kommission/GrabKommissionsarten',
        {
          params: {
            'sprache': state.currentUser!.uiLanguage.syzId
          }
        })

      return _.orderBy(CommissionGroup.createFromResponse(response.data), 'name')
    },

    async [actionTypes.FETCH_COMMISSION_DATA] ({ commit, state }, id: number): Promise<KommissionResponse> {
      const response = await axios.get('/api/Kommission/GetKommission',
        {
          params: {
            kommission: id,
            sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_SEARCH_COMMISSION_LIST] ({ commit, state }, payload: KommissionSearchRequest): Promise<KommissionSearchResponse> {
      const response = await axios.post('/api/Kommission/Search', payload)
      return response.data
    },

    async [actionTypes.CREATE_COMMISSION] ({ commit, state }, payload: AddKommissionRequest): Promise<KommissionResponse> {
      const response = await axios.post('/api/Kommission/Add', payload)

      return response.data
    },

    async [actionTypes.UPDATE_COMMISSION] ({ commit, state }, payload: UpdateKommissionRequest): Promise<KommissionResponse> {
      const response = await axios.post('/api/Kommission/Update', payload)

      return response.data
    },

    async [actionTypes.DELETE_COMMISSION] ({ commit, state }, payload: number): Promise<ResponseBase> {
      const response = await axios.delete('/api/Kommission/Delete', {
        params: {
          kommissionId: payload
        }
      })

      return response.data
    },

    async [actionTypes.COPY_COMMISSION] ({ commit, state }, id: number): Promise<KommissionResponse> {
      const response = await axios.get('/api/Kommission/Copy',
        {
          params: {
            kommissionId: id,
            languageId: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_COMMISSION_ADDITIONAL] ({ commit, state }, id: number): Promise<KommissionAdditionalFieldsGetItemResponse> {
      const response = await axios.get('/api/Kommission/GetZusatzfelder',
        {
          params: {
            kommissionId: id,
            languageId: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.SAVE_COMMISSION_ADDITIONAL] ({ commit, state }, payload: UpsertKommissionZusatzfelderRequest): Promise<ResponseBase> {
      const response = await axios.post('/api/Kommission/UpsertKommissionZusatzfelder', payload)

      return response.data
    },

    async [actionTypes.FETCH_COMMISSION_SUBSCRIPTIONS] ({ commit, state }, id: number): Promise<KommissionAbonementeResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            sp: 'Kommission_GetAbonnemente',
            i_Kommission: id,
            i_Author: state.currentUser!.id
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_COMMISSION_SUBSCRIPTIONS_METADATA] ({ commit, state }): Promise<KommissionAbonementeMetadataResponse> {
      const response = await axios.get('/api/Automatic/GetMultipleWithMetadata',
        {
          params: {
            sp: 'Kommissionen_GetAbonnementeLists',
            i_Sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.UPSERT_SUBSCRIPTION] ({ commit, state }, payload: UpsertAbonnementeRequest): Promise<UpsertAbonnementeResponse> {
      const response = await axios.post('/api/Kommission/UpsertKommissionAbonnemente', payload)

      return response.data
    },

    async [actionTypes.DELETE_SUBSCRIPTION] ({ commit, state }, payload: number): Promise<ResponseBase> {
      const response = await axios.delete('/api/Kommission/DeleteAbonnemente',
        {
          params: {
            aboId: payload
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_COMMISSION_NOTES] ({ commit, state }, id: number): Promise<KommissionNotesResponse> {
      const response = await axios.get('/api/Automatic/GetMany',
        {
          params: {
            sp: 'Kommission_GetNotizen',
            i_Kommission: id,
            i_Author: state.currentUser!.id
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_COMMISSION_NOTES_METADATA] ({ commit, state }): Promise<KommissionNotesMetaDataResponse> {
      const response = await axios.get('/api/Automatic/GetMultipleWithMetadata',
        {
          params: {
            sp: 'Kommissione_GetNotizenLists',
            i_Sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.SAVE_COMMISSION_NOTE] ({ commit, state }, payload: UpsertKommissionNotizenRequest): Promise<KommissionNoteUpsertResponse> {
      const response = await axios.post('/api/Kommission/UpsertKommissionNotizen', payload)

      return response.data
    },

    async [actionTypes.DELETE_COMMISSION_NOTE] ({ commit, state }, payload: number): Promise<ResponseBase> {
      const response = await axios.delete('/api/Kommission/DeleteKommissionNotizen',
        {
          params: {
            noteId: payload
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_COCKPIT_DATA] ({ commit, state }, payload: FetchCockpitPayload): Promise<any> {
      const response = await axios.get('/api/Leitstand/ShowLeitstand',
        {
          params: payload
        })

      return response.data
    },

    async [actionTypes.FETCH_COCKPIT_STRUCTURE] (): Promise<LeitstandStructurResponse> {
      const response = await axios.get('/api/Leitstand/GetLeitstandStructur',
        {
          params: {
            ID: state.currentUser!.id,
            sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_DOCUMENT_GROUP] ({ commit, state }): Promise<DocumentGroupListResponse> {
      const response = await axios.get('/api/Automatic/GetMultipleWithMetadata',
        {
          params: {
            sp: 'Dokumente_GetLists',
            i_Sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_DOCUMENT_LIST] ({ commit, state }, payload: any): Promise<Document[]> {
      const response = await axios.get('/api/Document/GetDocumentAll',
        {
          params: {
            herkunft: payload.herkunft,
            recordid: payload.recordid
          }
        })

      return response.data ? Document.createListFromResponse(response.data) : []
    },

    async [actionTypes.FETCH_DOCUMENT_BY_ID] ({ commit, state }, payload: number): Promise<any> {
      const response = await axios.get('/api/Document/GetDocumentAttachmentById',
        {
          responseType: 'arraybuffer',
          params: {
            documentId: payload
          }
        })

      return response
    },

    async [actionTypes.SAVE_DOCUMENT_DATA] ({ commit, state }, payload: SaveDocumentAttachmentRequest): Promise<SaveDocumentResponse> {
      const response = await axios.post('/api/Document/SaveDocumentAttachment', payload)

      return response.data
    },

    async [actionTypes.EDIT_DOCUMENT_DATA] ({ commit, state }, payload: SaveDocumentAttachmentRequest): Promise<void> {
      await axios.post('/api/Document/EditDocument', null, {
        params: {
          documentid: payload.DokumentID,
          dokumentgruppe: payload.Gruppe,
          code: payload.Code ? payload.Code : '',
          bezeichnung: payload.Bezeichnung ? payload.Bezeichnung : '',
          autor: payload.Autor,
          kommentar: payload.Kommentar ? payload.Kommentar : '',
        }
      })
    },

    async [actionTypes.DELETE_DOCUMENT_DATA] ({ commit, state }, payload: number): Promise<ResponseBase> {
      const response = await axios.get('/api/Dokument/DeleteDocumentAttachment',
        {
          params: {
            documentID: payload
          }
        })

      return response.data
    },

    async [actionTypes.FETCH_CONFIGURATION] ({ commit, state }, payload: string): Promise<ProductNotesMetaDataResponse> {
      const response = await axios.get('/api/Automatic/GetMultiple',
        {
          params: {
            sp: payload,
            i_Sprache: state.selectedUiLanguage!.syzId
          }
        })

      return response.data
    },

  }
})
